"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  DEFAULT_SEARCH_PARAMS_ACCESS_TOKEN_STRATEGY: () => DEFAULT_SEARCH_PARAMS_ACCESS_TOKEN_STRATEGY,
  INSPECTION_RESULT_BY_LEGACY_VEREDICT: () => INSPECTION_RESULT_BY_LEGACY_VEREDICT,
  InspectionCompletedBy: () => import_ai_constants2.InspectionCompletedBy,
  InspectionResult: () => import_ai_constants2.InspectionResult,
  VerificationStatusEnum: () => VerificationStatusEnum,
  actionSources: () => actionSources,
  addonPlanSchema: () => addonPlanSchema,
  addonPlanSchemaBase: () => addonPlanSchemaBase,
  aggregatePaginateUsersRequestQuery: () => aggregatePaginateUsersRequestQuery,
  aggregatePaginateUsersResponseBody: () => aggregatePaginateUsersResponseBody,
  aggregatedAssetTypes: () => aggregatedAssetTypes,
  aggregatedFileAssetTypes: () => aggregatedFileAssetTypes,
  applyAddonPlanCustomValidations: () => applyAddonPlanCustomValidations,
  applyInvoiceRefinements: () => applyInvoiceRefinements,
  assetsSchema: () => assetsSchema,
  buildUserName: () => buildUserName,
  companySchema: () => companySchema,
  computeStatusFromDates: () => computeStatusFromDates,
  createAuthorizationURLRequestBody: () => createAuthorizationURLRequestBody,
  createAuthorizationURLResponseBody: () => createAuthorizationURLResponseBody,
  createInspectionPublicApiV2ResponseBodySchema: () => createInspectionPublicApiV2ResponseBodySchema,
  createInvoiceRequestBody: () => createInvoiceRequestBody,
  createInvoiceResponseBody: () => createInvoiceResponseBody,
  createSubscriptionRequestBody: () => createSubscriptionRequestBody,
  createSubscriptionRequestParams: () => createSubscriptionRequestParams,
  createSubscriptionResponseBody: () => createSubscriptionResponseBody,
  createZodTypeSafeEnumOpenApi: () => createZodTypeSafeEnumOpenApi,
  defaultInspectionTableColumns: () => defaultInspectionTableColumns,
  downloadInspectionsReportRequestBody: () => downloadInspectionsReportRequestBody,
  executeSegmentationSimulationRequestBody: () => executeSegmentationSimulationRequestBody,
  executeSegmentationSimulationResponseBody: () => executeSegmentationSimulationResponseBody,
  formatDateToLocale: () => formatDateToLocale,
  formatDateToLocaleDays: () => formatDateToLocaleDays,
  getCompaniesPaginationResponseBody: () => getCompaniesPaginationResponseBody,
  getVehicleAngleModelUrlResponseBody: () => getVehicleAngleModelUrlResponseBody,
  identityProviders: () => identityProviders,
  inspectionDetailDamagesResponseBody: () => inspectionDetailDamagesResponseBody,
  inspectionDetailIframeRequestQuerySchema: () => inspectionDetailIframeRequestQuerySchema,
  inspectionResults: () => import_ai_constants2.inspectionResults,
  invitationTokenHeaderName: () => invitationTokenHeaderName,
  invitationTokenRequestQuery: () => invitationTokenRequestQuery,
  inviteUsersRequestBody: () => inviteUsersRequestBody,
  inviteUsersResponseBody: () => inviteUsersResponseBody,
  invoiceRequestParams: () => invoiceRequestParams,
  listAllCompaniesResponseBody: () => listAllCompaniesResponseBody,
  listAssetInferenceChangelogsRequestQuery: () => listAssetInferenceChangelogsRequestQuery,
  listCompaniesRequestQuery: () => listCompaniesRequestQuery,
  listCompanySubscriptionsResponseBody: () => listCompanySubscriptionsResponseBody,
  listInferenceChangelogsResponseBodySchema: () => listInferenceChangelogsResponseBodySchema,
  listInspectionChangelogsRequestQuery: () => listInspectionChangelogsRequestQuery,
  listInspectionChangelogsResponseBodySchema: () => listInspectionChangelogsResponseBodySchema,
  listInvoicesRequestQuery: () => listInvoicesRequestQuery,
  listInvoicesResponseBody: () => listInvoicesResponseBody,
  listOfficeInspectionsRequestQuery: () => listOfficeInspectionsRequestQuery,
  listOfficeInspectionsResponseBody: () => listOfficeInspectionsResponseBody,
  listTemplatesPublicApiV2RequestQuerySchema: () => listTemplatesPublicApiV2RequestQuerySchema,
  listTemplatesPublicApiV2ResponseBodySchema: () => listTemplatesPublicApiV2ResponseBodySchema,
  loginBouncedRequestQuery: () => loginBouncedRequestQuery,
  loginUserIDPRequestBody: () => loginUserIDPRequestBody,
  loginUserRequestBody: () => loginUserRequestBody,
  normalizeEmail: () => normalizeEmail,
  officeInspectionListItemSchema: () => officeInspectionListItemSchema,
  officeUpdateTemplateRequestBody: () => officeUpdateTemplateRequestBody,
  onboardingInviteUsersRequestBody: () => onboardingInviteUsersRequestBody,
  planLimitSchema: () => planLimitSchema,
  planSchema: () => planSchema,
  prepareInvoiceDownloadRequestParams: () => prepareInvoiceDownloadRequestParams,
  prepareInvoiceDownloadResponseBody: () => prepareInvoiceDownloadResponseBody,
  publicSpecTemplateInferenceSchema: () => publicSpecTemplateInferenceSchema,
  publicSpecTemplateValidationSchema: () => publicSpecTemplateValidationSchema,
  registerClientInspectionEventRequestBody: () => registerClientInspectionEventRequestBody,
  registerClientInspectionEventResponseBody: () => registerClientInspectionEventResponseBody,
  registerCompanyRequestBody: () => registerCompanyRequestBody,
  registerCompanyResponseBody: () => registerCompanyResponseBody,
  registerEmailMembershipInvitationRequestBody: () => registerEmailMembershipInvitationRequestBody,
  registerEmailMembershipInvitationRequestParams: () => registerEmailMembershipInvitationRequestParams,
  registerEmailMembershipInvitationResponseBody: () => registerEmailMembershipInvitationResponseBody,
  registerInspectionErrorRequestBody: () => registerInspectionErrorRequestBody,
  registerInvitationIDPRequestBody: () => registerInvitationIDPRequestBody,
  registerUserEventRequestBody: () => registerUserEventRequestBody,
  registerUserGuestRequestBody: () => registerUserGuestRequestBody,
  requiredErrorFieldMessage: () => requiredErrorFieldMessage,
  resendInvitationEmailAdminRequestBody: () => resendInvitationEmailAdminRequestBody,
  resendInvitationEmailAdminResponseBody: () => resendInvitationEmailAdminResponseBody,
  retrieveCompanyRequestParams: () => retrieveCompanyRequestParams,
  retrieveCompanyResponseBody: () => retrieveCompanyResponseBody,
  retrieveCompanySubscriptionRequestQuery: () => retrieveCompanySubscriptionRequestQuery,
  retrieveCompanySubscriptionResponseBody: () => retrieveCompanySubscriptionResponseBody,
  retrieveGuestRequestParams: () => retrieveGuestRequestParams,
  retrieveGuestRequestQuery: () => retrieveGuestRequestQuery,
  retrieveGuestResponseBody: () => retrieveGuestResponseBody,
  retrieveInspectionProgressResponseBody: () => retrieveInspectionProgressResponseBody,
  retrieveInspectionPublicApiV2ResponseBodySchema: () => retrieveInspectionPublicApiV2ResponseBodySchema,
  retrieveInspectionSummaryRequestParams: () => retrieveInspectionSummaryRequestParams,
  retrieveMembershipFromInvitationRequestParams: () => retrieveMembershipFromInvitationRequestParams,
  retrieveMembershipFromInvitationResponseBody: () => retrieveMembershipFromInvitationResponseBody,
  retrieveSegmentationEvolutionRequestQuery: () => retrieveSegmentationEvolutionRequestQuery,
  retrieveSegmentationEvolutionResponseBody: () => retrieveSegmentationEvolutionResponseBody,
  retrieveSubscriptionRequestParams: () => retrieveSubscriptionRequestParams,
  retrieveTemplatePublicApiV2RequestParamsSchema: () => retrieveTemplatePublicApiV2RequestParamsSchema,
  retrieveTemplatePublicApiV2RequestQuerySchema: () => retrieveTemplatePublicApiV2RequestQuerySchema,
  retrieveTemplatePublicApiV2ResponseAssetsExample: () => retrieveTemplatePublicApiV2ResponseAssetsExample,
  retrieveTemplatePublicApiV2ResponseBodyExample: () => retrieveTemplatePublicApiV2ResponseBodyExample,
  retrieveTemplatePublicApiV2ResponseBodySchema: () => retrieveTemplatePublicApiV2ResponseBodySchema,
  retrieveTemplatePublicApiV2ResponseInferencesExample: () => retrieveTemplatePublicApiV2ResponseInferencesExample,
  retrieveTemplatePublicApiV2ResponseSchemaExample: () => retrieveTemplatePublicApiV2ResponseSchemaExample,
  retrieveTemplatePublicApiV2ResponseValidationsExample: () => retrieveTemplatePublicApiV2ResponseValidationsExample,
  searchPlanRequestQuery: () => searchPlanRequestQuery,
  searchPlanResponseBody: () => searchPlanResponseBody,
  signInMethodSchema: () => signInMethodSchema,
  similaritySearchRequestParams: () => similaritySearchRequestParams,
  similaritySearchRequestQuery: () => similaritySearchRequestQuery,
  similaritySearchResponseBody: () => similaritySearchResponseBody,
  similaritySearchSupportedAssetTypes: () => similaritySearchSupportedAssetTypes,
  sortLogicRules: () => sortLogicRules,
  subscribeToAddonPlanRequestBody: () => subscribeToAddonPlanRequestBody,
  templateInputWalkaroundAssetSchema: () => templateInputWalkaroundAssetSchema,
  templateInputWalkaroundSchema: () => templateInputWalkaroundSchema,
  timeAgo: () => timeAgo,
  toInspectionResultOption: () => toInspectionResultOption,
  tokenizeFileRequestBody: () => tokenizeFileRequestBody,
  updateCompanyConfigRequestBody: () => updateCompanyConfigRequestBody,
  updateCompanyRequestBody: () => updateCompanyRequestBody,
  updateCompanyRequestParams: () => updateCompanyRequestParams,
  updateInvoiceRequestBody: () => updateInvoiceRequestBody,
  updatePlanRequestBody: () => updatePlanRequestBody,
  updatePlanRequestParams: () => updatePlanRequestParams,
  updateSubscriptionRequestBody: () => updateSubscriptionRequestBody,
  updateTemplateRequestParams: () => updateTemplateRequestParams,
  userActivityBaseSchema: () => userActivityBaseSchema,
  variableActionReferences: () => variableActionReferences,
  webhookEventPublicApiV2Schema: () => webhookEventPublicApiV2Schema,
  webhookPublicApiV2EventsSpec: () => webhookPublicApiV2EventsSpec
});
module.exports = __toCommonJS(src_exports);

// src/interfaces/template.interface.ts
var variableActionReferences = [
  "variable",
  "constant",
  "input",
  "image"
];

// src/contracts/company.contract.ts
var import_zod = __toESM(require("zod"));
var listAllCompaniesResponseBody = import_zod.default.object({
  companies: import_zod.default.array(
    import_zod.default.object({
      _id: import_zod.default.string(),
      fantasyName: import_zod.default.string(),
      societyReason: import_zod.default.string()
    })
  )
});

// src/contracts/office.contracts.ts
var import_ai_constants = require("ai-constants");
var import_zod4 = require("zod");

// src/contracts/data-table.ts
var import_zod2 = require("zod");
var dataTableSortSchema = import_zod2.z.object({
  id: import_zod2.z.string(),
  desc: import_zod2.z.union([
    import_zod2.z.string().transform((value) => value === "true"),
    import_zod2.z.boolean()
  ])
});
var dataTableFiltersSchema = import_zod2.z.object({
  id: import_zod2.z.string(),
  value: import_zod2.z.string().transform(
    (value) => import_zod2.z.coerce.number().safeParse(value).success ? /* @__PURE__ */ new Date(+value) : value
  ).transform(
    (value) => value === "true" || value === "false" ? value === "true" : value
  ).transform((value) => value === "null" ? null : value),
  operator: import_zod2.z.enum(["eq", "ne", "gt", "gte", "lt", "lte"]),
  variant: import_zod2.z.string().nullish()
});
var dataTableRequestQuerySchema = import_zod2.z.object({
  page: import_zod2.z.coerce.number().min(1, "Page must be greater than 0").default(1),
  perPage: import_zod2.z.coerce.number().min(1, "Limit must be greater than 0").max(50).default(10),
  search: import_zod2.z.string().nullish(),
  filters: import_zod2.z.array(dataTableFiltersSchema).default([]),
  joinOperator: import_zod2.z.enum(["and", "or"]).default("and"),
  sort: import_zod2.z.array(dataTableSortSchema).default([])
});

// src/contracts/pagination.contract.ts
var import_zod3 = require("zod");
var createPaginationResponseSchema = (itemSchema) => import_zod3.z.object({
  items: import_zod3.z.array(itemSchema),
  meta: import_zod3.z.object({
    itemCount: import_zod3.z.number(),
    totalItems: import_zod3.z.number().nullish(),
    itemsPerPage: import_zod3.z.number(),
    totalPages: import_zod3.z.number().nullish(),
    currentPage: import_zod3.z.number()
  })
});

// src/contracts/office.contracts.ts
var listOfficeInspectionsRequestQuery = dataTableRequestQuerySchema.extend({});
var officeInspectionListItemSchema = import_zod4.z.object({
  _id: import_zod4.z.string(),
  producer: import_zod4.z.object({
    companyId: import_zod4.z.string().nullish(),
    userId: import_zod4.z.string(),
    membershipId: import_zod4.z.string(),
    firstName: import_zod4.z.string(),
    email: import_zod4.z.string(),
    companySocietyReason: import_zod4.z.string().nullish()
  }),
  status: import_zod4.z.enum(import_ai_constants.inspectionStatus),
  template: import_zod4.z.object({
    name: import_zod4.z.string()
  }),
  veredict: import_zod4.z.boolean().nullish(),
  result: import_zod4.z.enum(import_ai_constants.inspectionResults).nullish(),
  initDate: import_zod4.z.union([import_zod4.z.string(), import_zod4.z.null(), import_zod4.z.date()]),
  finishDate: import_zod4.z.union([import_zod4.z.string(), import_zod4.z.null(), import_zod4.z.date()]),
  createdAt: import_zod4.z.union([import_zod4.z.string(), import_zod4.z.date()]),
  type: import_zod4.z.enum(import_ai_constants.inspectionTypes)
});
var listOfficeInspectionsResponseBody = createPaginationResponseSchema(
  officeInspectionListItemSchema
);
var retrieveInspectionSummaryRequestParams = import_zod4.z.object({
  inspectionId: import_zod4.z.string().min(1, "Inspection ID is required")
});

// src/contracts/inspection.contract.ts
var import_zod5 = require("zod");
var import_ai_constants2 = require("ai-constants");
var inspectionDetailDamagesResponseBody = import_zod5.z.object({
  damages: import_zod5.z.object({
    grouped: import_zod5.z.array(
      import_zod5.z.object({
        image: import_zod5.z.object({
          _id: import_zod5.z.any(),
          templateImageIdentifier: import_zod5.z.string(),
          label: import_zod5.z.string()
        }),
        damages: import_zod5.z.array(
          import_zod5.z.object({
            part: import_zod5.z.string(),
            severity: import_zod5.z.string(),
            damage: import_zod5.z.string()
          })
        )
      })
    ),
    declared: import_zod5.z.boolean(),
    inferred: import_zod5.z.boolean()
  })
});

// src/contracts/inference-changelog.contract.ts
var import_ai_constants3 = require("ai-constants");
var import_zod6 = require("zod");
var jsonPatchSchema = import_zod6.z.object({
  op: import_zod6.z.enum(import_ai_constants3.jsonPatchOperations),
  path: import_zod6.z.string(),
  displayPath: import_zod6.z.string(),
  oldValue: import_zod6.z.any(),
  value: import_zod6.z.any(),
  changeReason: import_zod6.z.string().nullish()
});
var actionSources = ["api", "user"];
var inferenceChangelogAssetSchema = import_zod6.z.object({
  type: import_zod6.z.enum(import_ai_constants3.processableAssetTypes),
  identifier: import_zod6.z.string()
});
var inferenceChangelogSchema = import_zod6.z.object({
  _id: import_zod6.z.any().nullish(),
  modelVersionId: import_zod6.z.any(),
  modelId: import_zod6.z.any(),
  assets: import_zod6.z.array(inferenceChangelogAssetSchema),
  changedFromAssetType: import_zod6.z.enum(import_ai_constants3.processableAssetTypes),
  changedFromAssetIdentifier: import_zod6.z.string(),
  inspectionId: import_zod6.z.any(),
  patches: import_zod6.z.array(jsonPatchSchema),
  updatedByUserEmail: import_zod6.z.string().nullish(),
  updatedByUserFullName: import_zod6.z.string().nullish(),
  assetInstanceIds: import_zod6.z.array(import_zod6.z.any()).nullish(),
  updatedByUsername: import_zod6.z.string().nullish(),
  updatedByUserId: import_zod6.z.any().nullish(),
  source: import_zod6.z.enum(actionSources).optional(),
  createdAt: import_zod6.z.coerce.date().nullish()
});
var listInferenceChangelogsResponseBodySchema = import_zod6.z.object({
  changelogs: import_zod6.z.array(inferenceChangelogSchema)
});
var listInspectionChangelogsRequestQuery = import_zod6.z.object({
  status: import_zod6.z.enum(["uncommitted", "committed"]).optional()
});
var listInspectionChangelogsResponseBodySchema = import_zod6.z.object({
  changelogs: import_zod6.z.array(inferenceChangelogSchema)
});
var listAssetInferenceChangelogsRequestQuery = import_zod6.z.object({
  assetType: import_zod6.z.enum(import_ai_constants3.processableAssetTypes),
  assetIdentifier: import_zod6.z.string(),
  assetInstanceId: import_zod6.z.string().nullish()
});

// src/schemas/inspection.ts
var import_ai_constants5 = require("ai-constants");
var import_zod7 = __toESM(require("zod"));

// src/table.ts
var import_ai_constants4 = require("ai-constants");
var import_i11n = require("i11n");

// src/utils/date.ts
var import_date_fns = require("date-fns");
var import_date_fns_tz = require("date-fns-tz");
var import_es = __toESM(require("date-fns/locale/es"));
var getZonedDate = (date, timezone) => {
  if (!date)
    return;
  const safeDate = new Date(date);
  if (Number.isNaN(safeDate.valueOf()))
    return;
  if (!timezone)
    return safeDate;
  return (0, import_date_fns_tz.utcToZonedTime)(safeDate, timezone);
};
var formatDateToLocale = (date, dateFormat = "P", context) => {
  if (!date)
    return;
  if (context == null ? void 0 : context.timezone) {
    return (0, import_date_fns_tz.formatInTimeZone)(date, context.timezone, dateFormat, {
      locale: import_es.default
    });
  }
  const zonedDate = getZonedDate(date);
  if (!zonedDate)
    return;
  return (0, import_date_fns.format)(zonedDate, dateFormat, {
    locale: import_es.default
  });
};
var formatDateToLocaleDays = (date, dateFormat = "P", context) => {
  if (!date)
    return;
  if (context == null ? void 0 : context.timezone) {
    return (0, import_date_fns_tz.formatInTimeZone)(date, context.timezone, dateFormat, {
      locale: import_es.default
    });
  }
  const dt = new Date(date);
  if (Number.isNaN(dt.valueOf()))
    return;
  const dtDateOnly = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1e3);
  return (0, import_date_fns.format)(dtDateOnly, dateFormat, {
    locale: import_es.default
  });
};
var timeAgo = (date, context) => {
  if (!date)
    return;
  const target = getZonedDate(date, context == null ? void 0 : context.timezone);
  if (!target)
    return;
  const now = getZonedDate(/* @__PURE__ */ new Date(), context == null ? void 0 : context.timezone) ?? /* @__PURE__ */ new Date();
  return (0, import_date_fns.formatDistance)(target, now, {
    addSuffix: true,
    locale: import_es.default
  });
};

// src/table.ts
var toInspectionResultOption = (result) => {
  if (result)
    return result;
  return import_ai_constants4.inspectionWithoutResult;
};
var defaultInspectionTableColumns = [
  {
    id: "name",
    header: "Nombre",
    mapper: (row) => {
      var _a, _b, _c, _d;
      const first = ((_b = (_a = row.consumer) == null ? void 0 : _a.firstName) == null ? void 0 : _b.toLowerCase()) ?? "";
      const last = ((_d = (_c = row.consumer) == null ? void 0 : _c.lastName) == null ? void 0 : _d.toLowerCase()) ?? "";
      const name = `${first} ${last}`.trim();
      return name || "-";
    }
  },
  {
    id: "identification",
    header: "DNI",
    mapper: (row) => {
      var _a;
      return ((_a = row.consumer) == null ? void 0 : _a.identification) ?? "-";
    }
  },
  {
    id: "inspectionId",
    header: "ID de inspecci\xF3n",
    mapper: (row) => row._id ?? "-"
  },
  {
    id: "createdAt",
    header: "Creada",
    mapper: (row, context) => timeAgo(row.createdAt ?? null, context) ?? ""
  },
  {
    id: "finishDate",
    header: "Finalizada",
    mapper: (row, context) => formatDateToLocale(row.finishDate ?? null, "Pp", context) ?? ""
  },
  {
    id: "type",
    header: "Tipo",
    mapper: (row) => row.type ? (0, import_i11n.t)(row.type) : ""
  },
  {
    id: "status",
    header: "Estado",
    mapper: (row) => row.status ? (0, import_i11n.t)(row.status) : ""
  },
  {
    id: "result",
    header: "Resultado",
    mapper: (row) => {
      const result = toInspectionResultOption(row.result);
      return (0, import_i11n.t)(result);
    }
  },
  {
    id: "template",
    header: "Plantilla",
    withoutLink: true,
    mapper: (row) => {
      var _a;
      return ((_a = row.template) == null ? void 0 : _a.name) ?? "";
    }
  },
  {
    id: "producer",
    header: "Creador",
    mapper: (row) => {
      var _a, _b, _c, _d, _e;
      if ((_a = row.producer) == null ? void 0 : _a.user)
        return [(_c = (_b = row.producer) == null ? void 0 : _b.user) == null ? void 0 : _c.firstName, (_e = (_d = row.producer) == null ? void 0 : _d.user) == null ? void 0 : _e.lastName].filter(Boolean).join(" ");
      return row.mode ?? "";
    }
  },
  {
    id: "review",
    header: "Revisi\xF3n",
    mapper: (row) => row.review ? (0, import_i11n.t)(row.review) : ""
  }
];
var table_default = defaultInspectionTableColumns;

// src/schemas/inspection.ts
var retrieveInspectionProgressResponseBody = import_zod7.default.object({
  _id: import_zod7.default.string(),
  status: import_zod7.default.enum(import_ai_constants5.inspectionStatus),
  notificationEvents: import_zod7.default.array(
    import_zod7.default.object({
      _id: import_zod7.default.string(),
      channel: import_zod7.default.enum(import_ai_constants5.notificationEventChannels),
      event: import_zod7.default.enum(import_ai_constants5.notificationEvents),
      metadata: import_zod7.default.object({
        inspectionId: import_zod7.default.string()
      })
    })
  ),
  accessCode: import_zod7.default.string()
});
var getVehicleAngleModelUrlResponseBody = import_zod7.default.object({
  modelKey: import_zod7.default.string().min(1),
  url: import_zod7.default.string().min(1)
});
var registerInspectionErrorRequestBody = import_zod7.default.object({
  name: import_zod7.default.string(),
  message: import_zod7.default.string(),
  stack: import_zod7.default.string().nullish(),
  url: import_zod7.default.string(),
  runtime: import_zod7.default.enum(["client", "server"])
});
var registerClientInspectionEventRequestBody = import_zod7.default.object({
  events: import_zod7.default.array(
    import_zod7.default.discriminatedUnion("event", [
      import_zod7.default.object({
        event: import_zod7.default.literal("inspection_app_webview_wall_viewed"),
        data: import_zod7.default.object({
          unix_timestamp_seconds: import_zod7.default.number()
        })
      }),
      import_zod7.default.object({
        event: import_zod7.default.literal("inspection_app_no_file_selected"),
        data: import_zod7.default.object({
          unix_timestamp_seconds: import_zod7.default.number()
        })
      }),
      import_zod7.default.object({
        event: import_zod7.default.literal("inspection_app_wrong_file_selected"),
        data: import_zod7.default.object({
          unix_timestamp_seconds: import_zod7.default.number(),
          file_name: import_zod7.default.string(),
          file_size_bytes: import_zod7.default.number().nullish(),
          file_mime_type: import_zod7.default.string().nullish()
        })
      }),
      import_zod7.default.object({
        event: import_zod7.default.literal("inspection_app_opened"),
        data: import_zod7.default.object({
          unix_timestamp_seconds: import_zod7.default.number(),
          source: import_zod7.default.enum(import_ai_constants5.inspectionLinkSources).nullish(),
          destination: import_zod7.default.string().nullish(),
          channel: import_zod7.default.enum(import_ai_constants5.notificationEventChannels).nullish()
        })
      }),
      import_zod7.default.object({
        event: import_zod7.default.literal("poor_connection_detected"),
        data: import_zod7.default.object({
          base_bandwidth_kbps: import_zod7.default.number(),
          file_size_bytes: import_zod7.default.number(),
          tolerated_upload_ms: import_zod7.default.number(),
          connection_type: import_zod7.default.enum(import_ai_constants5.navigatorConnectionTypes).default("unknown"),
          unix_timestamp_seconds: import_zod7.default.number(),
          section_identifier: import_zod7.default.string().nullish()
        })
      }),
      import_zod7.default.object({
        event: import_zod7.default.literal("inspection_section_viewed"),
        data: import_zod7.default.object({
          section_identifier: import_zod7.default.string(),
          unix_timestamp_seconds: import_zod7.default.number()
        })
      }),
      import_zod7.default.object({
        event: import_zod7.default.literal("inspection_section_completed"),
        data: import_zod7.default.object({
          section_identifier: import_zod7.default.string(),
          unix_timestamp_seconds: import_zod7.default.number()
        })
      }),
      import_zod7.default.object({
        event: import_zod7.default.literal("inspection_app_visibility_active"),
        data: import_zod7.default.object({
          section_identifier: import_zod7.default.string().nullish(),
          last_active_timestamp: import_zod7.default.number(),
          inactive_duration_ms: import_zod7.default.number(),
          unix_timestamp_seconds: import_zod7.default.number()
        })
      }),
      import_zod7.default.object({
        event: import_zod7.default.literal("inspection_app_visibility_inactive"),
        data: import_zod7.default.object({
          section_identifier: import_zod7.default.string().nullish(),
          last_active_timestamp: import_zod7.default.number(),
          active_duration_ms: import_zod7.default.number(),
          unix_timestamp_seconds: import_zod7.default.number()
        })
      })
    ])
  )
});
var registerClientInspectionEventResponseBody = import_zod7.default.object({
  registered: import_zod7.default.boolean()
});
var downloadInspectionsReportRequestBody = import_zod7.default.object({
  timezone: import_zod7.default.string(),
  columns: import_zod7.default.array(
    import_zod7.default.discriminatedUnion("type", [
      import_zod7.default.object({
        type: import_zod7.default.literal("default"),
        id: import_zod7.default.string().refine(
          (id) => table_default.some((c) => c.id === id),
          {
            message: "Invalid column id"
          }
        )
      }),
      import_zod7.default.object({
        type: import_zod7.default.literal("custom"),
        path: import_zod7.default.string()
      })
    ])
  )
});
var DEFAULT_SEARCH_PARAMS_ACCESS_TOKEN_STRATEGY = "oauth";
var inspectionDetailIframeRequestQuerySchema = import_zod7.default.object({
  inspectionId: import_zod7.default.string(),
  inspectionType: import_zod7.default.enum(import_ai_constants5.inspectionTypes),
  accessToken: import_zod7.default.string(),
  strategy: import_zod7.default.enum(["oauth", "presign"]).default(DEFAULT_SEARCH_PARAMS_ACCESS_TOKEN_STRATEGY)
});

// src/schemas/search.ts
var import_zod8 = require("zod");
var import_validator = require("validator");
var import_ai_constants6 = require("ai-constants");
var similaritySearchRequestParams = import_zod8.z.object({
  inspectionId: import_zod8.z.string().refine(import_validator.isMongoId)
});
var similaritySearchSupportedAssetTypes = [
  "input",
  "document",
  "image"
];
var similaritySearchAssetQueryBaseSchema = import_zod8.z.object({
  assetIdentifier: import_zod8.z.string()
});
var similaritySearchInputAssetQuerySchema = similaritySearchAssetQueryBaseSchema.extend({
  assetType: import_zod8.z.literal("input"),
  instanceId: import_zod8.z.string().optional()
});
var similaritySearchDocumentAssetQuerySchema = similaritySearchAssetQueryBaseSchema.extend({
  assetType: import_zod8.z.literal("document"),
  instanceId: import_zod8.z.string().optional()
});
var similaritySearchImageAssetQuerySchema = similaritySearchAssetQueryBaseSchema.extend({
  assetType: import_zod8.z.literal("image"),
  instanceId: import_zod8.z.string()
});
var similaritySearchRequestQuery = import_zod8.z.object({
  query: import_zod8.z.discriminatedUnion("assetType", [
    similaritySearchInputAssetQuerySchema,
    similaritySearchDocumentAssetQuerySchema,
    similaritySearchImageAssetQuerySchema
  ])
});
var similaritySearchResponseBody = import_zod8.z.object({
  matches: import_zod8.z.array(
    import_zod8.z.object({
      sourceData: import_zod8.z.object({
        title: import_zod8.z.string().nullish(),
        webLink: import_zod8.z.string().nullish(),
        fileUrl: import_zod8.z.string().nullish()
      }).nullish(),
      sourceType: import_zod8.z.enum(import_ai_constants6.inspectionFileSourceTypes),
      _id: import_zod8.z.custom(),
      url: import_zod8.z.string(),
      filename: import_zod8.z.string(),
      type: import_zod8.z.string(),
      similarity: import_zod8.z.number(),
      inspection: import_zod8.z.object({
        queryKeys: import_zod8.z.array(
          import_zod8.z.object({
            key: import_zod8.z.string(),
            value: import_zod8.z.string()
          })
        ),
        initDate: import_zod8.z.custom(),
        finishDate: import_zod8.z.custom(),
        createdAt: import_zod8.z.custom(),
        type: import_zod8.z.enum(import_ai_constants6.inspectionTypes),
        _id: import_zod8.z.custom(),
        status: import_zod8.z.enum(import_ai_constants6.inspectionStatus),
        completedBy: import_zod8.z.string().nullish(),
        consumer: import_zod8.z.object({
          firstName: import_zod8.z.string().nullish(),
          lastName: import_zod8.z.string().nullish(),
          identification: import_zod8.z.string().nullish()
        }),
        producer: import_zod8.z.object({
          userId: import_zod8.z.string().nullish(),
          firstName: import_zod8.z.string().nullish()
        })
      })
    })
  )
});

// src/schemas/plan.ts
var import_zod11 = require("zod");

// src/schemas/company.ts
var import_ai_constants7 = require("ai-constants");
var import_zod10 = require("zod");
var import_providers = require("@autoinspector/providers");

// src/schema.ts
var import_zod9 = require("zod");
var createZodTypeSafeEnumOpenApi = (values) => import_zod9.z.enum(values);

// src/utils/normalize-email.ts
var PLUS_ONLY = /\+.*$/;
var PLUS_AND_DOT = /\.|\+.*$/g;
var normalizeableProviders = {
  "gmail.com": {
    cut: PLUS_AND_DOT
  },
  "googlemail.com": {
    cut: PLUS_AND_DOT,
    aliasOf: "gmail.com"
  },
  "hotmail.com": {
    cut: PLUS_ONLY
  },
  "live.com": {
    cut: PLUS_AND_DOT
  },
  "outlook.com": {
    cut: PLUS_ONLY
  }
};
var normalize = (eMail) => {
  var email = eMail.toLowerCase();
  var emailParts = email.split(/@/);
  if (emailParts.length !== 2) {
    return eMail;
  }
  var username = emailParts[0];
  var domain = emailParts[1];
  if (normalizeableProviders.hasOwnProperty(domain)) {
    if (normalizeableProviders[domain].hasOwnProperty("cut")) {
      username = username.replace(normalizeableProviders[domain].cut, "");
    }
    if (normalizeableProviders[domain].hasOwnProperty("aliasOf")) {
      domain = normalizeableProviders[domain].aliasOf;
    }
  }
  return username + "@" + domain;
};
var normalizeEmail = (email = "") => {
  if (typeof email != "string") {
    return email;
  }
  return normalize(email.trim().toLowerCase());
};

// src/schemas/company.ts
var import_validator2 = require("validator");
var policySchema = import_zod10.z.object({
  name: import_zod10.z.string(),
  definition: import_zod10.z.object({
    rules: import_zod10.z.array(
      import_zod10.z.object({
        actions: import_zod10.z.array(
          import_zod10.z.object({
            action: createZodTypeSafeEnumOpenApi(
              import_providers.autoinspectorApiEnums.authzService.constantsRuleActionValues
            ),
            effect: createZodTypeSafeEnumOpenApi(
              import_providers.autoinspectorApiEnums.authzService.constantsPolicyEffectValues
            ),
            scope: createZodTypeSafeEnumOpenApi(
              import_providers.autoinspectorApiEnums.authzService.constantsPolicyScopeValues
            ).nullish()
          })
        ),
        resource: createZodTypeSafeEnumOpenApi(
          import_providers.autoinspectorApiEnums.authzService.constantsPolicyResourceValues
        )
      })
    )
  })
});
var planLimitSchema = import_zod10.z.object({
  overagePricePerUnit: import_zod10.z.number().min(0, "Debe ser mayor o igual a 0").nullish(),
  resource: import_zod10.z.enum(import_ai_constants7.planLimitResources),
  model: import_zod10.z.enum(import_ai_constants7.planLimitModels),
  quantity: import_zod10.z.number().min(0, "Debe ser mayor o igual a 0").or(import_zod10.z.literal(import_ai_constants7.UNLIMITED_MAGIC_NUMBER))
});
var planSchema = import_zod10.z.object({
  name: import_zod10.z.string().min(1),
  period: import_zod10.z.enum(import_ai_constants7.planPeriods),
  currency: import_zod10.z.enum(import_ai_constants7.currencies),
  amount: import_zod10.z.number().min(0),
  limits: import_zod10.z.array(planLimitSchema),
  description: import_zod10.z.string().nullish()
});
var applyAddonPlanCustomValidations = (schema) => (
  //@ts-ignore
  schema.refine(
    (data) => {
      if (!data.startDate && !data.endDate)
        return true;
      if (data.startDate && data.endDate)
        return new Date(data.startDate) < new Date(data.endDate);
      return true;
    },
    {
      message: "La fecha de inicio debe ser anterior a la fecha de fin",
      path: ["startDate", "endDate"]
    }
  )
);
var addonPlanSchemaBase = planSchema.extend({
  startDate: import_zod10.z.coerce.date().nullish(),
  endDate: import_zod10.z.coerce.date().nullish()
});
var addonPlanSchema = applyAddonPlanCustomValidations(addonPlanSchemaBase);
var registerCompanyRequestBody = import_zod10.z.object({
  domain: import_zod10.z.string().min(1, "Campo requerido").regex(/^[a-zA-Z0-9.-]+$/, "Dominio inv\xE1lido").refine((domain) => domain.split(".").length > 1, "Dominio inv\xE1lido"),
  societyReason: import_zod10.z.string().min(1, "Campo requerido"),
  fantasyName: import_zod10.z.string().min(1, "Campo requerido"),
  taxId: import_zod10.z.string().min(1, "Campo requerido"),
  legalAddress: import_zod10.z.string().min(1, "Campo requerido"),
  countryISO: import_zod10.z.string().min(1, "Campo requerido"),
  persons: import_zod10.z.array(
    import_zod10.z.object({
      role: import_zod10.z.enum(import_ai_constants7.companyRegistrationPersonRoles),
      firstName: import_zod10.z.string().min(1, "Campo requerido"),
      lastName: import_zod10.z.string().min(1, "Campo requerido"),
      email: import_zod10.z.string().email("Correo electr\xF3nico inv\xE1lido").transform((email) => normalizeEmail(email))
    })
  ).refine((persons) => persons.some((person) => person.role === "admin"), {
    message: "Debe haber al menos un administrador"
  }),
  subscription: import_zod10.z.object({
    startDate: import_zod10.z.coerce.date({
      errorMap: () => ({
        message: "Campo requerido"
      })
    }),
    endDate: import_zod10.z.coerce.date().nullish(),
    plan: planSchema,
    addonPlans: import_zod10.z.array(addonPlanSchema)
  }),
  policy: policySchema
});
var registerCompanyResponseBody = import_zod10.z.object({
  companyId: import_zod10.z.string(),
  guests: import_zod10.z.array(
    import_zod10.z.object({
      _id: import_zod10.z.any()
    })
  )
});
var companySchema = import_zod10.z.object({
  domain: import_zod10.z.string(),
  fantasyName: import_zod10.z.string(),
  _id: import_zod10.z.string(),
  cuit: import_zod10.z.string(),
  industry: import_zod10.z.string(),
  societyReason: import_zod10.z.string(),
  adminOwner: import_zod10.z.string(),
  location: import_zod10.z.object({
    country: import_zod10.z.string(),
    state: import_zod10.z.string(),
    address: import_zod10.z.string()
  }),
  persons: import_zod10.z.array(
    import_zod10.z.object({
      firstName: import_zod10.z.string(),
      lastName: import_zod10.z.string(),
      email: import_zod10.z.string(),
      role: import_zod10.z.enum(import_ai_constants7.companyRegistrationPersonRoles)
    })
  ),
  subscription: import_zod10.z.object({
    plan: import_zod10.z.object({
      name: import_zod10.z.string()
    })
  }),
  authConfig: import_zod10.z.object({
    email: import_zod10.z.boolean(),
    google: import_zod10.z.boolean(),
    microsoft: import_zod10.z.boolean()
  })
});
var getCompaniesPaginationResponseBody = import_zod10.z.object({
  data: import_zod10.z.array(companySchema),
  metadata: import_zod10.z.object({
    totalDocs: import_zod10.z.number(),
    limit: import_zod10.z.number(),
    totalPages: import_zod10.z.number()
  })
});
var resendInvitationEmailAdminRequestBody = import_zod10.z.object({
  companyId: import_zod10.z.string()
});
var resendInvitationEmailAdminResponseBody = import_zod10.z.object({
  sent: import_zod10.z.boolean(),
  email: import_zod10.z.string()
});
var onboardingInviteUsersRequestBody = import_zod10.z.object({
  emails: import_zod10.z.array(
    import_zod10.z.object({
      email: import_zod10.z.string().email({ message: "Correo inv\xE1lido" })
    })
  ).min(1, "M\xEDnimo un correo electr\xF3nico")
});
var retrieveCompanyRequestParams = import_zod10.z.object({
  companyId: import_zod10.z.string().min(1, "Company ID is required").refine(import_validator2.isMongoId)
});
var retrieveCompanyResponseBody = companySchema;
var listCompanySubscriptionsResponseBody = import_zod10.z.object({
  subscriptions: import_zod10.z.array(
    import_zod10.z.object({
      planId: import_zod10.z.any(),
      _id: import_zod10.z.string(),
      plan: registerCompanyRequestBody.shape.subscription.shape.plan.extend({
        _id: import_zod10.z.string()
      }),
      startDate: import_zod10.z.coerce.date(),
      endDate: import_zod10.z.coerce.date().nullish(),
      status: import_zod10.z.enum(import_ai_constants7.subscriptionStatuses)
    })
  )
});
var updateCompanyRequestBody = registerCompanyRequestBody.omit({
  subscription: true,
  policy: true
});
var updateCompanyRequestParams = retrieveCompanyRequestParams;
var VerificationStatusEnum = /* @__PURE__ */ ((VerificationStatusEnum2) => {
  VerificationStatusEnum2["PENDING"] = "pending";
  VerificationStatusEnum2["APPROVED"] = "approved";
  VerificationStatusEnum2["REJECTED"] = "rejected";
  return VerificationStatusEnum2;
})(VerificationStatusEnum || {});
var listCompaniesRequestQuery = dataTableRequestQuerySchema.extend({
  verificationStatus: import_zod10.z.nativeEnum(VerificationStatusEnum).nullish()
});
var aggregatePaginateUsersRequestQuery = dataTableRequestQuerySchema;
var userActivityBaseSchema = import_zod10.z.object({
  week: import_zod10.z.number(),
  year: import_zod10.z.number(),
  count: import_zod10.z.number(),
  inspection_created: import_zod10.z.number(),
  inspection_detail_viewed: import_zod10.z.number(),
  distinctRelevantEventDays: import_zod10.z.array(import_zod10.z.number())
});
var aggregatePaginateUsersResponseBody = createPaginationResponseSchema(
  import_zod10.z.object({
    _id: import_zod10.z.any(),
    email: import_zod10.z.string(),
    firstName: import_zod10.z.string().nullish(),
    lastName: import_zod10.z.string().nullish(),
    userId: import_zod10.z.any().nullish(),
    notificationEvents: import_zod10.z.custom(),
    policy: import_zod10.z.object({
      name: import_zod10.z.string()
    }),
    companySocietyReason: import_zod10.z.string().nullish(),
    companyFantasyName: import_zod10.z.string().nullish(),
    companyId: import_zod10.z.any(),
    createdAt: import_zod10.z.coerce.date(),
    segment: import_zod10.z.object({
      _id: import_zod10.z.any(),
      type: import_zod10.z.enum(import_ai_constants7.userSegmentTypes),
      timestamp: import_zod10.z.coerce.date()
    }).nullish(),
    activity: import_zod10.z.array(userActivityBaseSchema)
  })
).extend({
  percentages: import_zod10.z.array(
    import_zod10.z.object({
      segment: import_zod10.z.enum(import_ai_constants7.userSegmentTypes),
      percentage: import_zod10.z.number(),
      count: import_zod10.z.number()
    })
  )
});
var inviteUsersRequestBody = import_zod10.z.object({
  guests: import_zod10.z.array(
    import_zod10.z.object({
      email: import_zod10.z.string().email().refine(normalizeEmail),
      internalId: import_zod10.z.string().nullish()
    })
  ),
  policy: policySchema
});
var inviteUsersResponseBody = import_zod10.z.object({
  guests: import_zod10.z.array(
    import_zod10.z.object({
      email: import_zod10.z.string()
    })
  )
});
var updateCompanyConfigRequestBody = import_zod10.z.object({
  authConfig: import_zod10.z.object({
    email: import_zod10.z.boolean(),
    google: import_zod10.z.boolean(),
    microsoft: import_zod10.z.boolean()
  })
});

// src/schemas/plan.ts
var searchPlanRequestQuery = import_zod11.z.object({
  search: import_zod11.z.string().optional().nullish(),
  limit: import_zod11.z.number().max(30).default(10)
});
var searchPlanResponseBody = import_zod11.z.object({
  plans: import_zod11.z.array(
    planSchema.extend({
      _id: import_zod11.z.string(),
      subscription: import_zod11.z.object({
        company: import_zod11.z.object({
          fantasyName: import_zod11.z.string()
        })
      })
    })
  )
});
var updatePlanRequestParams = import_zod11.z.object({
  planId: import_zod11.z.string()
});
var updatePlanRequestBody = planSchema;

// src/schemas/auth.ts
var import_zod12 = __toESM(require("zod"));
var identityProviders = ["google", "microsoft"];
var emailSchema = import_zod12.default.string().min(1, "Campo requerido").email({
  message: "Correo electr\xF3nico inv\xE1lido"
}).transform(normalizeEmail);
var createAuthorizationURLRequestBody = import_zod12.default.object({
  idp: import_zod12.default.enum(identityProviders),
  invitationToken: import_zod12.default.string().nullish()
});
var createAuthorizationURLResponseBody = import_zod12.default.object({
  url: import_zod12.default.string()
});
var invitationTokenRequestQuery = import_zod12.default.object({
  token: import_zod12.default.string()
});
var invitationTokenHeaderName = "x-invitation-token";
var retrieveMembershipFromInvitationRequestParams = import_zod12.default.object({
  membershipId: import_zod12.default.string()
});
var retrieveMembershipFromInvitationResponseBody = import_zod12.default.object({
  email: emailSchema,
  firstName: import_zod12.default.string(),
  lastName: import_zod12.default.string(),
  membershipId: import_zod12.default.string(),
  invitationToken: import_zod12.default.string()
});
var registerEmailMembershipInvitationRequestParams = import_zod12.default.object({
  membershipId: import_zod12.default.string().min(1, "Membership ID is required")
});
var registerEmailMembershipInvitationRequestBody = import_zod12.default.object({
  password: import_zod12.default.string().min(8, "M\xEDnimo 8 caracteres")
});
var registerEmailMembershipInvitationResponseBody = import_zod12.default.object({
  email: emailSchema,
  firstName: import_zod12.default.string(),
  lastName: import_zod12.default.string()
});
var loginBouncedRequestQuery = import_zod12.default.object({
  error_code: import_zod12.default.enum([
    "not_found_user",
    "invitation_email_mismatch",
    "user_resource_limit_reached",
    "idp_not_allowed",
    "invalid_id_token"
  ]),
  idp: import_zod12.default.enum(identityProviders).nullish()
});
var loginUserRequestBody = import_zod12.default.object({
  email: emailSchema,
  password: import_zod12.default.string(),
  remember: import_zod12.default.boolean().optional()
});

// src/schemas/template.ts
var import_zod13 = require("zod");
var import_ai_constants8 = require("ai-constants");
var updateTemplateRequestParams = import_zod13.z.object({
  templateId: import_zod13.z.string().min(1)
});
var officeUpdateTemplateRequestBody = import_zod13.z.object({
  type: import_zod13.z.enum(import_ai_constants8.templateTypes)
});
var templateInputWalkaroundAssetSchema = import_zod13.z.object({
  type: import_zod13.z.literal("image"),
  identifier: import_zod13.z.string()
});
var templateInputWalkaroundSchema = import_zod13.z.object({
  enabled: import_zod13.z.boolean(),
  confidence: import_zod13.z.number().optional(),
  capture: import_zod13.z.boolean().optional(),
  assets: import_zod13.z.array(templateInputWalkaroundAssetSchema).optional()
});

// src/schemas/subscription.ts
var import_ai_constants9 = require("ai-constants");
var import_zod14 = __toESM(require("zod"));
var import_validator3 = require("validator");
var updateSubscriptionRequestBody = import_zod14.default.object({
  startDate: import_zod14.default.coerce.date().nullish(),
  endDate: import_zod14.default.coerce.date().nullish(),
  status: import_zod14.default.enum(import_ai_constants9.subscriptionStatuses).nullish(),
  addonPlans: import_zod14.default.array(
    applyAddonPlanCustomValidations(
      addonPlanSchemaBase.extend({
        _id: import_zod14.default.string().nullish(),
        status: import_zod14.default.enum(import_ai_constants9.subscriptionStatuses).nullish()
      })
    )
  ).nullish()
});
var retrieveSubscriptionRequestParams = import_zod14.default.object({
  subscriptionId: import_zod14.default.string()
});
var createSubscriptionRequestBody = registerCompanyRequestBody.shape.subscription.refine(
  (data) => !data.endDate || data.startDate < data.endDate,
  {
    message: "La fecha de inicio debe ser anterior a la fecha de fin",
    path: ["startDate"]
  }
);
var createSubscriptionResponseBody = import_zod14.default.object({
  subscription: import_zod14.default.object({
    _id: import_zod14.default.string(),
    plan: import_zod14.default.object({
      name: import_zod14.default.string()
    })
  })
});
var createSubscriptionRequestParams = import_zod14.default.object({
  companyId: import_zod14.default.string().min(1, "Company ID is required")
});
var prepareInvoiceDownloadRequestParams = import_zod14.default.object({
  invoiceId: import_zod14.default.string().refine(import_validator3.isMongoId)
});
var prepareInvoiceDownloadResponseBody = import_zod14.default.object({
  url: import_zod14.default.string()
});
var subscribeToAddonPlanRequestBody = import_zod14.default.object({
  addonPlanId: import_zod14.default.string()
});

// src/schemas/public-template-v2.ts
var import_ai_constants10 = require("ai-constants");
var import_validator4 = require("validator");
var import_zod15 = __toESM(require("zod"));
var retrieveTemplatePublicApiV2RequestParamsSchema = import_zod15.default.object({
  templateId: import_zod15.default.string().refine(import_validator4.isMongoId, {
    message: "Invalid template id. It should be a 24-character hexadecimal string."
  })
});
var retrieveTemplatePublicApiV2RequestQuerySchema = import_zod15.default.object({
  stage: import_zod15.default.enum(import_ai_constants10.inspectionStages).optional().describe(
    "Stage to consider when building template assets schema. By default all stages are considered."
  )
});
var aggregatedAssetTypes = [...import_ai_constants10.inputTypes, "image"];
var aggregatedFileAssetTypes = [
  ...import_ai_constants10.strictInputTypeFiles,
  "image"
];
var commonAssetSchema = import_zod15.default.object({
  identifier: import_zod15.default.string().describe("Asset identifier"),
  label: import_zod15.default.string().describe("Asset label"),
  stages: import_zod15.default.array(import_zod15.default.enum(import_ai_constants10.inspectionStages))
});
var assetsSchema = import_zod15.default.array(
  import_zod15.default.discriminatedUnion("type", [
    commonAssetSchema.extend({
      type: import_zod15.default.literal("text"),
      validation: import_zod15.default.object({
        required: import_zod15.default.boolean(),
        minLength: import_zod15.default.number(),
        maxLength: import_zod15.default.number(),
        email: import_zod15.default.boolean()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod15.default.literal("numeric"),
      validation: import_zod15.default.object({
        required: import_zod15.default.boolean(),
        minimum: import_zod15.default.number(),
        maximum: import_zod15.default.number(),
        minDigits: import_zod15.default.number(),
        maxDigits: import_zod15.default.number()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod15.default.literal("select"),
      validation: import_zod15.default.object({
        required: import_zod15.default.boolean()
      }),
      options: import_zod15.default.array(
        import_zod15.default.object({
          label: import_zod15.default.string().describe("Option label")
        })
      )
    }),
    commonAssetSchema.extend({
      type: import_zod15.default.literal("multiselect"),
      validation: import_zod15.default.object({
        required: import_zod15.default.boolean(),
        minOptions: import_zod15.default.number(),
        maxOptions: import_zod15.default.number()
      }),
      options: import_zod15.default.array(
        import_zod15.default.object({
          label: import_zod15.default.string().describe("Option label")
        })
      )
    }),
    commonAssetSchema.extend({
      type: import_zod15.default.literal("date"),
      validation: import_zod15.default.object({
        required: import_zod15.default.boolean(),
        minDate: import_zod15.default.string().datetime(),
        maxDate: import_zod15.default.string().datetime()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod15.default.enum(["file", "video", "audio"]),
      validation: import_zod15.default.object({
        required: import_zod15.default.boolean()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod15.default.literal("checkboxGroup"),
      validation: import_zod15.default.object({
        required: import_zod15.default.boolean(),
        minOptions: import_zod15.default.number(),
        maxOptions: import_zod15.default.number()
      }),
      options: import_zod15.default.array(
        import_zod15.default.object({
          label: import_zod15.default.string().describe("Option label")
        })
      )
    }),
    commonAssetSchema.extend({
      type: import_zod15.default.literal("dialogDecision"),
      validation: import_zod15.default.object({
        required: import_zod15.default.boolean()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod15.default.literal("signature"),
      validation: import_zod15.default.object({
        required: import_zod15.default.boolean()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod15.default.literal("image"),
      validation: import_zod15.default.object({
        required: import_zod15.default.boolean()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod15.default.literal("textarea"),
      validation: import_zod15.default.object({
        required: import_zod15.default.boolean(),
        minLength: import_zod15.default.number(),
        maxLength: import_zod15.default.number()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod15.default.literal("check"),
      validation: import_zod15.default.object({
        required: import_zod15.default.boolean()
      })
    })
  ])
).describe("Template assets spec");
var publicSpecTemplateValidationSchema = import_zod15.default.object({
  identifier: import_zod15.default.string().nonempty().describe(
    "Identifier of the validation. Use this to programmatically reference the validation."
  ),
  title: import_zod15.default.string().nonempty().describe("Human readable validation title"),
  description: import_zod15.default.string().nonempty().describe("Human readable validation description"),
  bindings: import_zod15.default.object({
    assets: import_zod15.default.array(
      import_zod15.default.object({
        identifier: import_zod15.default.string().nonempty().describe("Identifier of the asset"),
        type: import_zod15.default.enum(aggregatedAssetTypes).describe("Type of the asset")
      })
    ).describe("Assets dependencies of the validation")
  }).describe("Dependencies of the validation")
}).describe("Validation results");
var publicSpecTemplateInferenceSchema = import_zod15.default.object({
  identifier: import_zod15.default.string().nonempty().describe(
    "Identifier of the inference. Use this to programmatically reference the inference."
  ),
  title: import_zod15.default.string().nonempty().describe("Human readable inference title"),
  bindings: import_zod15.default.object({
    assets: import_zod15.default.array(
      import_zod15.default.object({
        identifier: import_zod15.default.string().nonempty().describe("Identifier of the asset"),
        type: import_zod15.default.enum(aggregatedAssetTypes).describe("Type of the asset")
      })
    )
  }).describe("To which assets the inference is bound to"),
  schema: import_zod15.default.record(import_zod15.default.string(), import_zod15.default.any()).describe("Inference value JSON Schema")
});
var retrieveTemplatePublicApiV2ResponseSchemaExample = {
  type: ["object"],
  properties: {
    assets: {
      type: ["array"],
      items: {
        discriminator: {
          propertyName: "identifier"
        },
        oneOf: [
          {
            type: ["object"],
            properties: {
              label: {
                type: ["string"],
                enum: ["Nombre"]
              },
              identifier: {
                type: ["string"],
                enum: ["input_799d0410-6f9f-4336-acd1-9dde9af158bd"]
              },
              type: {
                type: ["string"],
                enum: ["text"]
              },
              value: {
                type: ["string"]
              }
            },
            required: ["identifier", "type", "value"]
          },
          {
            type: ["object"],
            properties: {
              label: {
                type: ["string"],
                enum: ["Apellido"]
              },
              identifier: {
                type: ["string"],
                enum: ["input_7c9c6f4b-b74d-4842-b6fa-b59e6e1d57b5"]
              },
              type: {
                type: ["string"],
                enum: ["text"]
              },
              value: {
                type: ["string"]
              }
            },
            required: ["identifier", "type", "value"]
          },
          {
            type: ["object"],
            properties: {
              label: {
                type: ["string"],
                enum: ["File"]
              },
              identifier: {
                type: ["string"],
                enum: ["input_12f97833-f738-42bf-8b7e-10b27ae964b9"]
              },
              type: {
                type: ["string"],
                enum: ["file"]
              },
              value: {
                type: ["string"],
                description: "File Object ID"
              }
            },
            required: ["identifier", "type", "value"]
          }
        ]
      }
    }
  },
  required: ["assets"]
};
var retrieveTemplatePublicApiV2ResponseAssetsExample = [
  {
    identifier: "input_799d0410-6f9f-4336-acd1-9dde9af158bd",
    label: "Nombre",
    type: "text",
    validation: {
      required: true,
      minLength: 2,
      maxLength: 60,
      email: false
    },
    stages: ["create"]
  },
  {
    identifier: "input_7c9c6f4b-b74d-4842-b6fa-b59e6e1d57b5",
    label: "Apellido",
    type: "text",
    validation: {
      required: true,
      minLength: 2,
      maxLength: 60,
      email: false
    },
    stages: ["create"]
  },
  {
    identifier: "input_12f97833-f738-42bf-8b7e-10b27ae964b9",
    label: "File",
    type: "file",
    validation: {
      required: true
    },
    stages: ["create"]
  }
];
var retrieveTemplatePublicApiV2ResponseValidationsExample = [
  {
    identifier: "69823dd4f18d7435a9c487b1",
    title: "Validacion de Persona",
    description: "Verifica que en la imagen de selfie sea una persona",
    bindings: {
      assets: [
        {
          identifier: "image_b1ac0f90-34d4-4049-a807-a752bb36eb4f",
          type: "image"
        }
      ]
    }
  }
];
var retrieveTemplatePublicApiV2ResponseInferencesExample = [
  {
    identifier: "vehicle_brand",
    title: "Vehicle Brand",
    bindings: {
      assets: [
        {
          type: "image",
          identifier: "image_3416b703-2aad-4beb-9cf1-422b3eeda98f"
        }
      ]
    },
    schema: {
      type: "string",
      title: "Detected Brand"
    }
  }
];
var retrieveTemplatePublicApiV2ResponseBodySchema = import_zod15.default.object({
  _id: import_zod15.default.string().describe("Template ID"),
  name: import_zod15.default.string().describe("Template name"),
  status: import_zod15.default.enum(import_ai_constants10.templateStatus).describe("Template status"),
  createdAt: import_zod15.default.string().datetime().describe("Template creation date"),
  updatedAt: import_zod15.default.string().datetime().describe("Template last update date"),
  publishedAt: import_zod15.default.string().datetime().describe("Template publication date").optional(),
  schema: import_zod15.default.record(import_zod15.default.string(), import_zod15.default.any()).describe("Template assets JSON Schema"),
  assets: assetsSchema,
  validations: import_zod15.default.array(publicSpecTemplateValidationSchema),
  inferences: import_zod15.default.array(publicSpecTemplateInferenceSchema)
});
var retrieveTemplatePublicApiV2ResponseBodyExample = {
  _id: "65f8f2c8a4a5b1c2d3e4f5a6",
  name: "Inspeccion Auto - Produccion",
  status: "published",
  createdAt: "2026-02-17T19:00:00.000Z",
  updatedAt: "2026-02-17T19:30:00.000Z",
  publishedAt: "2026-02-17T19:30:00.000Z",
  schema: retrieveTemplatePublicApiV2ResponseSchemaExample,
  assets: retrieveTemplatePublicApiV2ResponseAssetsExample,
  validations: retrieveTemplatePublicApiV2ResponseValidationsExample,
  inferences: retrieveTemplatePublicApiV2ResponseInferencesExample
};
var listTemplatesPublicApiV2RequestQuerySchema = import_zod15.default.object({
  limit: import_zod15.default.coerce.number().min(1).max(10).default(10),
  page: import_zod15.default.coerce.number().min(1).default(1),
  status: import_zod15.default.enum(import_ai_constants10.templateStatus).optional()
});
var listTemplatesPublicApiV2ResponseBodySchema = import_zod15.default.object({
  data: import_zod15.default.array(
    retrieveTemplatePublicApiV2ResponseBodySchema.omit({
      assets: true,
      inferences: true,
      validations: true,
      schema: true
    })
  ),
  meta: import_zod15.default.object({
    total: import_zod15.default.number().describe("Total number of templates"),
    page: import_zod15.default.number().describe("Current page"),
    limit: import_zod15.default.number().describe("Limit per page"),
    hasMore: import_zod15.default.boolean().describe("If there are more templates to fetch")
  })
});

// src/schemas/public-inspection-v2.ts
var import_ai_constants11 = require("ai-constants");
var import_validator5 = require("validator");
var import_zod16 = __toESM(require("zod"));
var metadataSchema = import_zod16.default.record(import_zod16.default.string().max(50), import_zod16.default.string().max(500)).refine((data) => Object.keys(data).length <= 50, {
  message: "Metadata cannot have more than 50 keys"
});
var createInspectionPublicApiV2ResponseBodySchema = import_zod16.default.object({
  _id: import_zod16.default.string().refine(import_validator5.isMongoId, {
    message: "Invalid inspection id. It should be a 24-character hexadecimal string."
  }),
  magicLink: import_zod16.default.string().nonempty().describe("URL to access the inspection"),
  accessCode: import_zod16.default.string().nonempty().describe("Security code to access the inspection"),
  metadata: metadataSchema,
  status: import_zod16.default.enum(import_ai_constants11.inspectionStatus).describe("Status of the inspection")
});
var persistedDeclaredAssetSchema = import_zod16.default.discriminatedUnion("type", [
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("text"),
    value: import_zod16.default.string().nonempty()
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("textarea"),
    value: import_zod16.default.string().nonempty()
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("audio"),
    value: import_zod16.default.string().nonempty().describe("File Object ID"),
    url: import_zod16.default.string().nonempty().describe("Presigned URL to access the file")
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("image"),
    value: import_zod16.default.string().nonempty().describe("File Object ID"),
    url: import_zod16.default.string().nonempty().describe("Presigned URL to access the file")
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("video"),
    value: import_zod16.default.string().nonempty().describe("File Object ID"),
    url: import_zod16.default.string().nonempty().describe("Presigned URL to access the file")
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("file"),
    value: import_zod16.default.string().nonempty().describe("File Object ID"),
    url: import_zod16.default.string().nonempty().describe("Presigned URL to access the file")
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("signature"),
    value: import_zod16.default.string().nonempty().describe("File Object ID"),
    url: import_zod16.default.string().nonempty().describe("Presigned URL to access the file")
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("date"),
    value: import_zod16.default.string().nonempty().datetime()
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("select"),
    value: import_zod16.default.string().nonempty()
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("numeric"),
    value: import_zod16.default.number().nonnegative()
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("check"),
    value: import_zod16.default.boolean()
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("multiselect"),
    value: import_zod16.default.array(
      import_zod16.default.object({
        selected: import_zod16.default.string().nonempty()
      })
    )
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("dialogDecision"),
    value: import_zod16.default.boolean()
  }),
  import_zod16.default.object({
    identifier: import_zod16.default.string().nonempty(),
    type: import_zod16.default.literal("checkboxGroup"),
    value: import_zod16.default.array(
      import_zod16.default.object({
        selected: import_zod16.default.string().nonempty()
      })
    )
  })
]);
var validationResults = ["approved", "disapproved"];
var retrieveInspectionPublicApiV2ResponseBodySchema = createInspectionPublicApiV2ResponseBodySchema.extend({
  result: import_zod16.default.enum(import_ai_constants11.inspectionResults).describe(
    "Result of the inspection. Only available when the inspection is finished"
  ).optional(),
  validations: import_zod16.default.array(
    publicSpecTemplateValidationSchema.extend({
      result: import_zod16.default.enum(validationResults)
    })
  ),
  inferences: import_zod16.default.array(
    publicSpecTemplateInferenceSchema.extend({
      value: import_zod16.default.union([
        import_zod16.default.string(),
        import_zod16.default.number(),
        import_zod16.default.boolean(),
        import_zod16.default.array(import_zod16.default.string()),
        import_zod16.default.array(import_zod16.default.number()),
        import_zod16.default.array(import_zod16.default.boolean())
      ])
    })
  ),
  assets: import_zod16.default.array(persistedDeclaredAssetSchema)
});

// src/schemas/public-webhook-v2.ts
var import_zod_openapi = require("@anatine/zod-openapi");
var import_ai_constants12 = require("ai-constants");
var import_zod17 = __toESM(require("zod"));
var webhookProducerPayloadSchema = import_zod17.default.object({
  companyId: import_zod17.default.string(),
  email: import_zod17.default.string().optional(),
  firstName: import_zod17.default.string().optional(),
  internalId: import_zod17.default.string().optional(),
  lastName: import_zod17.default.string().optional(),
  membershipId: import_zod17.default.string().optional(),
  userId: import_zod17.default.string().optional(),
  username: import_zod17.default.string().optional()
}).passthrough();
var webhookTemplateSummaryPayloadSchema = import_zod17.default.object({
  _id: import_zod17.default.string(),
  name: import_zod17.default.string(),
  type: import_zod17.default.string()
}).passthrough();
var webhookTemplateInputPayloadSchema = import_zod17.default.object({
  identifier: import_zod17.default.string(),
  label: import_zod17.default.string(),
  type: import_zod17.default.string().optional(),
  value: import_zod17.default.unknown().optional()
}).passthrough();
var inspectionStatusWebhookPayloadV1Schema = import_zod17.default.object({
  _id: import_zod17.default.string(),
  magicLink: import_zod17.default.string().optional(),
  metadata: import_zod17.default.record(import_zod17.default.string(), import_zod17.default.unknown()).optional(),
  parentInspectionId: import_zod17.default.string().optional(),
  producer: webhookProducerPayloadSchema,
  status: import_zod17.default.enum(import_ai_constants12.inspectionStatus),
  template: webhookTemplateSummaryPayloadSchema,
  testing: import_zod17.default.boolean(),
  type: import_zod17.default.enum(import_ai_constants12.inspectionTypes)
}).passthrough();
var inspectionImageProcessedItemPayloadSchema = import_zod17.default.object({
  _id: import_zod17.default.string(),
  image: import_zod17.default.object({}).passthrough(),
  type: import_zod17.default.string().optional()
}).passthrough();
var inspectionImageProcessedWebhookPayloadV1Schema = import_zod17.default.object({
  _id: import_zod17.default.string(),
  custom: inspectionImageProcessedItemPayloadSchema.optional(),
  entities: import_zod17.default.array(import_zod17.default.unknown()).optional(),
  identity: inspectionImageProcessedItemPayloadSchema.optional(),
  inspection: import_zod17.default.object({
    image: import_zod17.default.object({}).passthrough()
  }).passthrough().optional(),
  metadata: import_zod17.default.record(import_zod17.default.string(), import_zod17.default.unknown()).optional(),
  producer: webhookProducerPayloadSchema,
  product: inspectionImageProcessedItemPayloadSchema.optional(),
  scope: import_zod17.default.enum(import_ai_constants12.assetTargets),
  template: webhookTemplateSummaryPayloadSchema,
  testing: import_zod17.default.boolean(),
  type: import_zod17.default.enum(import_ai_constants12.inspectionTypes)
}).passthrough();
var inspectionGlobalValidationWebhookPayloadV1Schema = import_zod17.default.object({
  _id: import_zod17.default.string(),
  description: import_zod17.default.string(),
  name: import_zod17.default.string(),
  valid: import_zod17.default.boolean()
}).passthrough();
var inspectionContextSectionWebhookPayloadV1Schema = import_zod17.default.object({
  extraImages: import_zod17.default.array(import_zod17.default.object({}).passthrough()).optional(),
  images: import_zod17.default.array(import_zod17.default.object({}).passthrough()).optional(),
  inputs: import_zod17.default.array(webhookTemplateInputPayloadSchema).optional()
}).passthrough();
var inspectionProductWebhookPayloadV1Schema = import_zod17.default.object({
  _id: import_zod17.default.string(),
  extraImages: import_zod17.default.array(import_zod17.default.object({}).passthrough()).optional(),
  images: import_zod17.default.array(import_zod17.default.object({}).passthrough()).optional(),
  inputs: import_zod17.default.array(webhookTemplateInputPayloadSchema).optional(),
  type: import_zod17.default.string()
}).passthrough();
var inspectionCompletedWebhookPayloadV1Schema = import_zod17.default.object({
  _id: import_zod17.default.string(),
  completedBy: import_zod17.default.enum(import_ai_constants12.inspectionCompletedBy).optional(),
  custom: inspectionContextSectionWebhookPayloadV1Schema.optional(),
  functions: import_zod17.default.array(import_zod17.default.unknown()).optional(),
  globalValidations: import_zod17.default.array(inspectionGlobalValidationWebhookPayloadV1Schema).optional(),
  identity: inspectionContextSectionWebhookPayloadV1Schema.optional(),
  metadata: import_zod17.default.record(import_zod17.default.string(), import_zod17.default.unknown()).optional(),
  producer: webhookProducerPayloadSchema,
  products: import_zod17.default.array(inspectionProductWebhookPayloadV1Schema).optional(),
  status: import_zod17.default.enum(import_ai_constants12.inspectionStatus),
  template: webhookTemplateSummaryPayloadSchema.extend({
    inputs: import_zod17.default.array(webhookTemplateInputPayloadSchema).optional()
  }).passthrough(),
  testing: import_zod17.default.boolean(),
  type: import_zod17.default.enum(import_ai_constants12.inspectionTypes),
  variables: import_zod17.default.array(import_zod17.default.unknown()).optional(),
  veredict: import_zod17.default.enum(import_ai_constants12.inspectionResults)
}).passthrough();
var buildWebhookEventSchema = ({
  description,
  event,
  example,
  payloadSchema,
  title
}) => (0, import_zod_openapi.extendApi)(
  import_zod17.default.object({
    event: import_zod17.default.literal(event),
    payload: payloadSchema
  }),
  {
    title,
    description,
    example
  }
);
var inspectionCompletedWebhookPayloadV1Example = {
  _id: "65f8f73aa4a5b1c2d3e4f5f0",
  metadata: {
    policy_id: "POL-10021"
  },
  producer: {
    companyId: "65f8f2c8a4a5b1c2d3e4f5a6",
    internalId: "user_240"
  },
  status: "completed",
  template: {
    _id: "65f8f2c8a4a5b1c2d3e4f5a6",
    name: "Inspecci\xF3n vehicular",
    type: "car"
  },
  testing: false,
  type: "car",
  veredict: "approved"
};
var inspectionCompletedWebhookPayloadV2Example = {
  _id: "65f8f73aa4a5b1c2d3e4f5f0",
  magicLink: "https://app.autoinspector.ai/inspection/65f8f73aa4a5b1c2d3e4f5f0",
  accessCode: "381144",
  metadata: {
    policy_id: "POL-10021",
    external_claim_id: "CLM-92811"
  },
  status: "completed",
  result: "approved",
  validations: [
    {
      identifier: "validation_plate",
      title: "Patente v\xE1lida",
      description: "Valida formato de la patente",
      bindings: {
        assets: [
          {
            identifier: "input_vehicle_plate",
            type: "text"
          }
        ]
      },
      result: "approved"
    }
  ],
  inferences: [
    {
      identifier: "inference_damage_score",
      title: "Puntaje de da\xF1o",
      bindings: {
        assets: [
          {
            identifier: "input_vehicle_plate",
            type: "text"
          }
        ]
      },
      schema: {
        type: "number"
      },
      value: 0.12
    }
  ],
  assets: [
    {
      identifier: "input_vehicle_plate",
      type: "text",
      value: "AB123CD"
    }
  ]
};
var inspectionCreatedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "inspection_created",
  example: {
    event: "inspection_created",
    payload: {
      _id: "651ae032ff786d198dfa4ce4",
      status: "created",
      producer: {
        userId: "61478404b9a70800551878b6",
        membershipId: "61c28b777b0c420012bd4a68",
        companyId: "6147843bb9a70800551878bd",
        firstName: "John",
        lastName: "Doe",
        username: "johndoe",
        email: "johndoe@gmail.com"
      },
      type: "car",
      metadata: {
        my_custom_key: "my_custom_value"
      },
      testing: false,
      template: {
        name: "easy",
        type: "built-in",
        _id: "62be865212ca0918bcabf2a5"
      },
      magicLink: "https://app.autoinspector.ai/inspection/651ae032ff786d198dfa4ce4?accessCode=5087"
    }
  },
  payloadSchema: inspectionStatusWebhookPayloadV1Schema,
  title: "Inspection Created v1",
  description: "When an inspection is created."
});
var childrenInspectionCreatedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "children_inspection_created",
  example: {
    event: "children_inspection_created",
    payload: {
      _id: "657b2dc8fa2a696fcd56946b",
      parentInspectionId: "657b1a7d2f1446f1b9ee0552",
      status: "created",
      producer: {
        userId: "61478404b9a70800551878b6",
        membershipId: "61c28b777b0c420012bd4a68",
        companyId: "6147843bb9a70800551878bd",
        firstName: "Luciano",
        username: "lcnlvrzz",
        email: "lucianoalvarez1212@gmail.com",
        lastName: "Alvarez"
      },
      type: "car",
      metadata: {
        templateId: "657b17d89b8f27657c96c315",
        parentInspectionId: "657b1a7d2f1446f1b9ee0552"
      },
      testing: false,
      template: {
        name: "UNIQUE AUTO CUSTOM",
        type: "created",
        _id: "657b17d89b8f27657c96c315"
      },
      magicLink: "https://app.autoinspector.ai/inspection/651ae032ff786d198dfa4ce4?accessCode=5087"
    }
  },
  payloadSchema: inspectionStatusWebhookPayloadV1Schema,
  title: "Children Inspection Created v1",
  description: "When an inspection is recreated from an expired inspection."
});
var inspectionStartedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "inspection_started",
  example: {
    event: "inspection_started",
    payload: {
      _id: "651ae032ff786d198dfa4ce4",
      status: "started",
      producer: {
        userId: "61478404b9a70800551878b6",
        membershipId: "61c28b777b0c420012bd4a68",
        companyId: "6147843bb9a70800551878bd",
        firstName: "John",
        lastName: "Doe",
        username: "johndoe",
        email: "johndoe@gmail.com"
      },
      type: "car",
      metadata: {
        my_custom_key: "my_custom_value"
      },
      testing: false,
      template: {
        name: "easy",
        type: "built-in",
        _id: "62be865212ca0918bcabf2a5"
      }
    }
  },
  payloadSchema: inspectionStatusWebhookPayloadV1Schema,
  title: "Inspection Started v1",
  description: "When an inspection is started by the user."
});
var inspectionImageProcessedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "image_processed",
  example: {
    event: "image_processed",
    payload: {
      _id: "651ae032ff786d198dfa4ce4",
      producer: {
        userId: "61478404b9a70800551878b6",
        membershipId: "61c28b777b0c420012bd4a68",
        companyId: "6147843bb9a70800551878bd",
        firstName: "John",
        lastName: "Doe",
        username: "johndoe",
        email: "johndoe@gmail.com"
      },
      type: "car",
      metadata: {
        my_custom_key: "my_custom_value"
      },
      testing: false,
      template: {
        name: "easy",
        type: "built-in",
        _id: "62be865212ca0918bcabf2a5"
      },
      entities: [],
      scope: "product",
      product: {
        _id: "651ae032ff786d198dfa4cf1",
        image: {
          entities: [],
          templateImageIdentifier: "image_3e1153f3-66fa-4463-973a-fe277894c9df",
          type: "normal",
          target: "product",
          side: "back",
          processed: true,
          uploadedAt: "2023-10-02T15:29:53.000Z",
          _id: "651ae1f2ff786d198dfa4e20",
          validations: [
            {
              confidence: 99.99993896484375,
              identifier: "candidate_96b69c40-5ef9-46c3-899e-e0ed37ee6d02",
              valid: true,
              validation: "object",
              required: true
            },
            {
              confidence: 95.7,
              identifier: "candidate_04f8f69c-d817-4fe2-b3f8-64ba09f7ebd0",
              valid: true,
              validation: "make",
              required: true
            },
            {
              confidence: 95.7,
              identifier: "candidate_2a66f6bc-77a7-44f3-aea7-bdd4b24c4cce",
              valid: true,
              validation: "model",
              required: true
            },
            {
              confidence: 99,
              identifier: "candidate_b8848e93-1c11-4876-9869-9adaa1f4ab6e",
              valid: true,
              validation: "plate",
              required: true
            },
            {
              confidence: 90,
              identifier: "candidate_696f64c3-b8fe-4382-9905-b539540b709f",
              valid: true,
              validation: "domain",
              required: true
            },
            {
              confidence: 92.80000000000001,
              identifier: "candidate_cd9227dc-3dd3-4f7d-be35-2d139e84cd4d",
              valid: true,
              validation: "angle",
              required: true
            },
            {
              confidence: 99.98935461044312,
              identifier: "candidate_81f1306b-b904-4afa-a1e5-f183a2d040c5",
              valid: true,
              validation: "color",
              required: true
            },
            {
              confidence: 99.99420642852783,
              identifier: "candidate_371b8a6f-b459-412a-8586-fb9af15b90eb",
              valid: true,
              validation: "complete",
              required: true
            },
            {
              confidence: 100,
              identifier: "candidate_d191cd50-5ed7-4b11-88b3-6f35dc5677dd",
              valid: true,
              validation: "date",
              required: false
            },
            {
              confidence: 100,
              identifier: "candidate_328142df-4e12-4009-9774-291266500358",
              valid: true,
              validation: "distance",
              required: false
            },
            {
              confidence: 98.23,
              identifier: "candidate_e16b1d8d-016c-4174-8d5f-9f5ce28f0369",
              valid: true,
              validation: "recaptured",
              required: false
            },
            {
              confidence: 100,
              identifier: "candidate_0665678c-4c72-4c45-b2e1-37c9b6ff4ce4",
              valid: false,
              validation: "damage",
              required: false
            }
          ],
          approved: true,
          src: "https://ai-inspections.s3.amazonaws.com/back-1696260591720.jpeg",
          damages: [
            {
              part: "trunk",
              percentage: 1.97,
              damage: "dent"
            }
          ]
        }
      }
    }
  },
  payloadSchema: inspectionImageProcessedWebhookPayloadV1Schema,
  title: "Image Processed v1",
  description: "When an image is processed and its validations have been executed."
});
var inspectionBlockedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "inspection_blocked",
  example: {
    event: "inspection_blocked",
    payload: {
      _id: "651ae032ff786d198dfa4ce4",
      status: "blocked",
      producer: {
        userId: "61478404b9a70800551878b6",
        membershipId: "61c28b777b0c420012bd4a68",
        companyId: "6147843bb9a70800551878bd",
        firstName: "John",
        lastName: "Doe",
        username: "johndoe",
        email: "johndoe@gmail.com"
      },
      type: "car",
      metadata: {
        my_custom_key: "my_custom_value"
      },
      testing: false,
      template: {
        name: "easy",
        type: "built-in",
        _id: "62be865212ca0918bcabf2a5"
      }
    }
  },
  payloadSchema: inspectionStatusWebhookPayloadV1Schema,
  title: "Inspection Blocked v1",
  description: "When an inspection gets blocked."
});
var inspectionCompletedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "inspection_completed",
  example: {
    event: "inspection_completed",
    payload: inspectionCompletedWebhookPayloadV1Example
  },
  payloadSchema: inspectionCompletedWebhookPayloadV1Schema,
  title: "Inspection Completed v1",
  description: "When an inspection is completed and has a final veredict in API version v1 format."
});
var inspectionReviewedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "inspection_reviewed",
  example: {
    event: "inspection_reviewed",
    payload: {
      _id: "646ee7dc5b7220a2e2ed76b8",
      status: "completed",
      producer: {
        userId: "61478404b9a70800551878b6",
        membershipId: "61c28b777b0c420012bd4a68",
        companyId: "6147843bb9a70800551878bd",
        firstName: "John",
        lastName: "Doe",
        username: "johndoe",
        email: "johndoe@gmail.com"
      },
      metadata: {
        my_custom_key: "my_custom_value"
      },
      testing: false,
      template: {
        _id: "62be865212ca0918bcabf2a5",
        name: "easy",
        type: "built-in",
        inputs: [
          {
            identifier: "input_bf5dd369-3a82-4b0d-b8be-5186da9c07c7",
            label: "Nombre",
            value: "John"
          },
          {
            identifier: "input_db30b856-594e-4799-9ee9-2dacfbe2a338",
            label: "Apellido",
            value: "Doe"
          },
          {
            identifier: "input_79519a40-3047-48c4-b8db-5c95c8b5166a",
            label: "Identificaci\xF3n",
            value: "44188219"
          },
          {
            identifier: "input_1b00981a-1484-4f53-8702-2a6d43fd6662",
            label: "Email",
            value: "johndoe@gmail.com"
          },
          {
            identifier: "input_79bdb79b-c3d4-40d5-905e-bdaf1f1e02cb",
            label: "Ciudad",
            value: "testing"
          },
          {
            identifier: "input_a00ae5cb-e633-4b9a-98b8-863eeac96e5c",
            label: "Pa\xEDs",
            value: "AR"
          },
          {
            identifier: "input_53ca83e7-413a-4435-9c2f-8206630142a8",
            label: "Provincia",
            value: "T"
          },
          {
            identifier: "input_21de8e3a-87c9-474a-9f10-a4dc9ecbf083",
            label: "Sexo",
            value: "male"
          },
          {
            identifier: "input_25dd4378-395d-4fe6-8306-65dcead884b0",
            label: "Nacimiento",
            value: "2002-06-19T00:00:00.000Z"
          },
          {
            identifier: "input_3f8023b1-2062-4679-b455-f69a1211af1e",
            label: "Direcci\xF3n",
            value: "testing 100"
          },
          {
            identifier: "input_f2aaa964-9944-4d04-b86c-33044d00fef6",
            label: "Tel\xE9fono",
            value: "03813635420"
          },
          {
            identifier: "input_35c6a25f-6407-4755-a225-47d72bc02530",
            label: "Patente",
            value: "AZ204SU"
          },
          {
            identifier: "input_9f7a5106-09ae-49ab-a58a-b28952725ce0",
            label: "A\xF1o",
            value: 2020
          },
          {
            identifier: "input_e7f39d45-cf28-422f-a643-4f6e81127065",
            label: "Color",
            value: "grey"
          },
          {
            identifier: "input_23fa1c2b-b87f-4780-92d8-f8665f21288b",
            label: "Uso",
            value: "PRIVADO"
          },
          {
            identifier: "input_8e20f135-42b9-42cc-9ab5-abc4d32cdea3",
            label: "Marca",
            value: "JEEP"
          },
          {
            identifier: "input_0f2e6fb5-ca87-480a-984f-0afa54d5f924",
            label: "Modelo",
            value: "RENEGADE"
          }
        ]
      },
      veredict: "approved",
      type: "car",
      completedBy: "client",
      identity: {
        images: [
          {
            validations: [
              {
                validation: "date",
                _id: "62cd9215ecac9905ccf303d5",
                confidence: 100,
                valid: true
              },
              {
                validation: "distance",
                _id: "62cd9215ecac9905ccf303d6",
                confidence: 100,
                valid: true
              },
              {
                validation: "recaptured",
                _id: "62cd9215ecac9905ccf303d7",
                confidence: 95.01,
                valid: true
              },
              {
                validation: "face_comparison",
                _id: "62cd9215ecac9905ccf303d8",
                confidence: 100,
                valid: true
              }
            ],
            entities: [
              {
                entity: "passport",
                valid: true,
                result: {
                  sex: "M",
                  surname: "CASTILLO",
                  givenNames: "JUAN PABLO",
                  nationality: "ARGENTINA",
                  dateOfBirth: "21 FEB/FEB 87",
                  placeOfBirth: "ARG",
                  dateOfIssue: "13 JUN/JUN 16",
                  dateOfExpiry: "13 JUN/JUN 26",
                  personalNumber: "32815355",
                  authority: "RENAPER",
                  documentNumber: "AAE054537",
                  issuingCountry: "ARG"
                }
              }
            ],
            damages: [],
            side: "pasaporte",
            processed: true,
            uploadedAt: "2022-07-12T15:22:56.000Z",
            _id: "62cd920cecac9905ccf3032d",
            approved: true,
            src: "https://ai-inspections.s3.amazonaws.com/pasaporte-1657639433699.jpeg",
            target: "identity"
          },
          {
            validations: [
              {
                validation: "date",
                _id: "62cd9215ecac9905ccf303d5",
                confidence: 100,
                valid: true
              },
              {
                validation: "distance",
                _id: "62cd9215ecac9905ccf303d6",
                confidence: 100,
                valid: true
              },
              {
                validation: "recaptured",
                _id: "62cd9215ecac9905ccf303d7",
                confidence: 95.01,
                valid: true
              },
              {
                validation: "face_comparison",
                _id: "62cd9215ecac9905ccf303d8",
                confidence: 100,
                valid: true
              },
              {
                validation: "birthdate",
                _id: "62cd9215ecac9905ccf303d9",
                confidence: 100,
                valid: false
              },
              {
                validation: "dni",
                _id: "62cd9215ecac9905ccf303db",
                confidence: 100,
                valid: true
              },
              {
                validation: "full_name",
                _id: "62cd9215ecac9905ccf303de",
                confidence: 100,
                valid: true
              },
              {
                validation: "sex",
                _id: "62cd9215ecac9905ccf303e0",
                confidence: 100,
                valid: true
              },
              {
                validation: "age",
                _id: "62cd9215ecac9905ccf303e2",
                confidence: 100,
                valid: false
              },
              {
                validation: "object",
                _id: "62cd9215ecac9905ccf303e3",
                confidence: 98.41889953613281,
                valid: true
              }
            ],
            damages: [],
            side: "dni",
            processed: true,
            uploadedAt: "2022-07-12T15:23:56.000Z",
            _id: "62cd920cecac9905ccf3039d",
            approved: true,
            src: "https://ai-inspections.s3.amazonaws.com/dni-1657639433699.jpeg",
            target: "identity"
          },
          {
            validations: [
              {
                validation: "date",
                _id: "62cd9210ecac9905ccf303bd",
                confidence: 100,
                valid: true
              },
              {
                validation: "distance",
                _id: "62cd9210ecac9905ccf303be",
                confidence: 100,
                valid: true
              },
              {
                validation: "recaptured",
                _id: "62cd9210ecac9905ccf303bf",
                confidence: 99.95,
                valid: true
              },
              {
                validation: "age",
                _id: "62cd9210ecac9905ccf303c0",
                confidence: 99.99873352050781,
                valid: true
              },
              {
                validation: "face_comparison",
                _id: "62cd9210ecac9905ccf303c1",
                confidence: 0,
                valid: false
              },
              {
                validation: "object",
                _id: "62cd9210ecac9905ccf303c2",
                confidence: 99.8077163696289,
                valid: true
              }
            ],
            damages: [],
            side: "selfie",
            processed: true,
            uploadedAt: "2022-07-12T15:23:56.000Z",
            _id: "62cd920cecac9905ccf303a7",
            approved: true,
            src: "https://ai-inspections.s3.amazonaws.com/selfie-1657639435560.jpeg",
            target: "identity"
          }
        ],
        extraImages: [],
        email: "lucianoalvarez1212@gmail.com",
        firstName: "Luciano",
        identification: "44188219",
        lastName: "Alvarez"
      },
      custom: {
        images: [],
        inputs: [
          {
            label: "Seleccione los accesorios que desea asegurar",
            type: "multiselect",
            identifier: "input_525a71d5-3e1d-47e3-b2f5-1238d33190be",
            value: [
              {
                selected: "Llantas especiales"
              },
              {
                selected: "Radio"
              }
            ]
          }
        ],
        extraImages: []
      },
      products: [
        {
          type: "car",
          car: {
            plate: "AZ204SU",
            color: "grey",
            make: "JEEP",
            model: "RENEGADE",
            use: "PRIVADO",
            year: 2020
          },
          _id: "646ee7dd5b7220a2e2ed76c5",
          extraImages: [],
          inputs: [],
          images: [
            {
              templateImageIdentifier: "image_3e1153f3-66fa-4463-973a-fe277894c9df",
              type: "normal",
              target: "product",
              side: "back",
              processed: true,
              uploadedAt: "2023-05-25T04:46:40.000Z",
              _id: "646ee8305b7220a2e2ed7718",
              validations: [
                {
                  confidence: 99.99993896484375,
                  identifier: "candidate_2b136747-6293-4fe8-abf5-1532a7d97581",
                  valid: true,
                  validation: "object",
                  required: true
                },
                {
                  confidence: 95.7,
                  identifier: "candidate_df69203b-a9f1-4225-bfbb-5df5198b806f",
                  valid: true,
                  validation: "make",
                  required: true
                },
                {
                  confidence: 95.7,
                  identifier: "candidate_20168d44-92b5-4e71-967d-7dbddf042718",
                  valid: true,
                  validation: "model",
                  required: true
                },
                {
                  confidence: 99,
                  identifier: "candidate_f2249ef8-8360-4b35-b8f7-c941dfd9a3ba",
                  valid: true,
                  validation: "plate",
                  required: true
                },
                {
                  confidence: 90,
                  identifier: "candidate_228671dc-c9a2-48d9-b3f0-632f362fc136",
                  valid: true,
                  validation: "domain",
                  required: true
                },
                {
                  confidence: 92.80000000000001,
                  identifier: "candidate_3e18a4b3-7b1d-4cd5-bf69-22dfc5e6f37a",
                  valid: true,
                  validation: "angle",
                  required: true
                },
                {
                  confidence: 99.98935461044312,
                  identifier: "candidate_0748121d-42b8-40f3-8889-90d88cbdf17f",
                  valid: true,
                  validation: "color",
                  required: true
                },
                {
                  confidence: 99.99420642852783,
                  identifier: "candidate_2514b86c-6ba6-4c4f-8eb1-450090ceb819",
                  valid: true,
                  validation: "complete",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_4bb107a9-9c46-430f-835f-541650635caf",
                  valid: true,
                  validation: "date",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_028b92d5-a8cc-4c6e-85fa-220c2927687b",
                  valid: true,
                  validation: "distance",
                  required: false
                },
                {
                  confidence: 98.23,
                  identifier: "candidate_c65a8d0c-62c1-4732-9317-b08237fce958",
                  valid: true,
                  validation: "recaptured",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_c40b3705-64e8-4faa-9648-bea7df4e8389",
                  valid: false,
                  validation: "damage",
                  required: false
                }
              ],
              approved: true,
              src: "https://ai-inspections.s3.amazonaws.com/back-1684989998800.jpeg",
              damages: [
                {
                  part: "trunk",
                  percentage: 1.97,
                  damage: "dent"
                }
              ]
            },
            {
              templateImageIdentifier: "image_69c8e668-7c20-489e-ace8-74d4d5cc833a",
              type: "normal",
              target: "product",
              side: "front",
              processed: true,
              uploadedAt: "2023-05-25T04:46:44.000Z",
              _id: "646ee8345b7220a2e2ed7769",
              validations: [
                {
                  confidence: 99.80770111083984,
                  identifier: "candidate_18276ec7-7502-4ed4-a067-f54f745bb50e",
                  valid: true,
                  validation: "object",
                  required: true
                },
                {
                  confidence: 92.5,
                  identifier: "candidate_2b58b84d-ff4b-4cf1-9615-7f735659de17",
                  valid: true,
                  validation: "make",
                  required: true
                },
                {
                  confidence: 92.5,
                  identifier: "candidate_fa7b952a-cd6a-449c-ba1d-8106e522de41",
                  valid: true,
                  validation: "model",
                  required: true
                },
                {
                  confidence: 99,
                  identifier: "candidate_e7a7b281-2bbc-4b8b-b76f-9acc13f5000f",
                  valid: true,
                  validation: "plate",
                  required: true
                },
                {
                  confidence: 89.7,
                  identifier: "candidate_ef42b770-1721-410e-ae77-93b0fa5c1028",
                  valid: true,
                  validation: "domain",
                  required: true
                },
                {
                  confidence: 90.9,
                  identifier: "candidate_ce035a0a-9d75-4bcd-94bc-b10d806d67c9",
                  valid: true,
                  validation: "angle",
                  required: true
                },
                {
                  confidence: 0.14095206279307604,
                  identifier: "candidate_0ba18bf2-075e-45d0-988a-64a7c9d21b3c",
                  valid: true,
                  validation: "color",
                  required: true
                },
                {
                  confidence: 96.16938829421997,
                  identifier: "candidate_cae171db-1b0a-4351-8bca-052517c31703",
                  valid: true,
                  validation: "complete",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_b2fb826a-06b2-4d82-a9f6-a8a0dd700804",
                  valid: true,
                  validation: "date",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_a7bef5c9-f877-4928-94f4-6417c277395b",
                  valid: true,
                  validation: "distance",
                  required: false
                },
                {
                  confidence: 97.65,
                  identifier: "candidate_36812f63-4a21-492c-9e56-9b3a8426c629",
                  valid: true,
                  validation: "recaptured",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_470dd1b6-c020-44e2-99ea-018decba540d",
                  valid: true,
                  validation: "damage",
                  required: false
                }
              ],
              approved: true,
              src: "https://ai-inspections.s3.amazonaws.com/front-1684990002943.jpeg",
              damages: []
            },
            {
              templateImageIdentifier: "image_36d5963f-c1c3-4f81-86dd-cf26e7e2d965",
              type: "normal",
              target: "product",
              side: "sideLeft",
              processed: true,
              uploadedAt: "2023-05-25T04:46:49.000Z",
              _id: "646ee83a5b7220a2e2ed7779",
              validations: [
                {
                  confidence: 99.4636001586914,
                  identifier: "candidate_cdf7cdf8-b74e-41eb-add0-edbbbb272520",
                  valid: true,
                  validation: "object",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_dbf52417-c8d3-4c1f-b680-e470c8fe79c0",
                  valid: true,
                  validation: "date",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_e8a20066-c99e-48aa-9914-c62a863cc90e",
                  valid: true,
                  validation: "distance",
                  required: false
                },
                {
                  confidence: 99.24,
                  identifier: "candidate_37c278f8-0561-43a9-94b9-b08c118d3ddb",
                  valid: false,
                  validation: "recaptured",
                  required: false
                },
                {
                  confidence: 47.30112850666046,
                  identifier: "candidate_e42c0c0e-61ee-4b16-b6f8-721dc0ef46ad",
                  valid: true,
                  validation: "angle",
                  required: true
                },
                {
                  confidence: 20.524100959300995,
                  identifier: "candidate_7045b92f-fc79-4984-92b1-7fb7524b7754",
                  valid: true,
                  validation: "color",
                  required: true
                },
                {
                  confidence: 99.16438460350037,
                  identifier: "candidate_8f4c77aa-0553-4541-9a96-c55945b02975",
                  valid: true,
                  validation: "complete",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_38cdd9f1-c4a5-4470-ac50-aa918ee253f5",
                  valid: true,
                  validation: "damage",
                  required: false
                }
              ],
              approved: true,
              src: "https://ai-inspections.s3.amazonaws.com/sideleft-1684990007888.jpeg",
              damages: []
            },
            {
              templateImageIdentifier: "image_44849b74-b3a7-4914-9bf5-180a04e27e44",
              type: "normal",
              target: "product",
              side: "sideRight",
              processed: true,
              uploadedAt: "2023-05-25T04:46:52.000Z",
              _id: "646ee83c5b7220a2e2ed7793",
              validations: [
                {
                  confidence: 99.34487915039062,
                  identifier: "candidate_fff0264f-6540-41ab-a96a-a98569c96153",
                  valid: true,
                  validation: "object",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_c8b9bf42-a4ba-4709-ac99-acd58e02b22b",
                  valid: true,
                  validation: "date",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_54faadcc-b7c5-4f87-9cfd-7fe5aa071a5b",
                  valid: true,
                  validation: "distance",
                  required: false
                },
                {
                  confidence: 96.16,
                  identifier: "candidate_b3d3f3b7-17c6-4323-a120-63328ec9fe8f",
                  valid: true,
                  validation: "recaptured",
                  required: false
                },
                {
                  confidence: 99.29338693618774,
                  identifier: "candidate_dc40f817-3483-4d1d-8bbd-46f9b1bb823e",
                  valid: true,
                  validation: "angle",
                  required: true
                },
                {
                  confidence: 98.33864569664001,
                  identifier: "candidate_b5982ae4-3441-4b97-b598-2a45618d97d1",
                  valid: true,
                  validation: "color",
                  required: true
                },
                {
                  confidence: 68.27582120895386,
                  identifier: "candidate_56c5c0f4-dbcf-42c0-9d67-306795251c45",
                  valid: true,
                  validation: "complete",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_607dee9e-672d-43b6-83e8-f52cd6080697",
                  valid: true,
                  validation: "damage",
                  required: false
                }
              ],
              approved: true,
              src: "https://ai-inspections.s3.amazonaws.com/sideright-1684990010964.jpeg",
              damages: []
            },
            {
              templateImageIdentifier: "image_b7118054-16af-4fe8-b6ec-7bf216a553cf",
              type: "normal",
              target: "product",
              side: "id",
              processed: true,
              uploadedAt: "2023-05-25T04:46:56.000Z",
              _id: "646ee8405b7220a2e2ed77aa",
              validations: [
                {
                  confidence: 93.64836120605469,
                  identifier: "candidate_e610ab3e-ed99-4d37-baab-f17f6abd1cab",
                  valid: true,
                  validation: "object",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_8b4d60a7-8966-4c29-b4cb-976ec0ec2ab3",
                  valid: true,
                  validation: "model",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_9eef5161-9344-45a8-b313-37400bb30a79",
                  valid: true,
                  validation: "make",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_d6d80bb8-6edb-4d0e-9aee-7f653ee8a4ee",
                  valid: true,
                  validation: "use",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_ea2175cf-4d2d-4818-a25f-1028f35a52a8",
                  valid: true,
                  validation: "domain",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_ec46c9eb-fdf8-4427-9b7b-df20d9a098de",
                  valid: true,
                  validation: "vin",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_5f059ca8-6b97-4d27-9cd8-2ca08f72624a",
                  valid: true,
                  validation: "date",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_a33e7367-b037-4197-b8d6-95ba0c78ccea",
                  valid: true,
                  validation: "distance",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_3a25a739-7697-4ba0-a249-9f70fb2b5e44",
                  valid: true,
                  validation: "recaptured",
                  required: false
                }
              ],
              approved: true,
              src: "https://ai-inspections.s3.amazonaws.com/id-1684990015188.jpeg",
              damages: []
            }
          ]
        }
      ]
    }
  },
  payloadSchema: inspectionCompletedWebhookPayloadV1Schema,
  title: "Inspection Reviewed v1",
  description: "When a completed inspection has been reviewed and changed in API version v1 format."
});
var inspectionCompletedWebhookEventPayloadV2Schema = buildWebhookEventSchema({
  event: "inspection_completed",
  example: {
    event: "inspection_completed",
    payload: inspectionCompletedWebhookPayloadV2Example
  },
  payloadSchema: retrieveInspectionPublicApiV2ResponseBodySchema,
  title: "Inspection Completed v2",
  description: "When an inspection is completed and have a result. At this stage assets, inferences and validations were computed."
});
var webhookEventSchemas = [
  inspectionCreatedWebhookEventPayloadV1Schema,
  childrenInspectionCreatedWebhookEventPayloadV1Schema,
  inspectionStartedWebhookEventPayloadV1Schema,
  inspectionImageProcessedWebhookEventPayloadV1Schema,
  inspectionBlockedWebhookEventPayloadV1Schema,
  inspectionCompletedWebhookEventPayloadV1Schema,
  inspectionReviewedWebhookEventPayloadV1Schema,
  inspectionCompletedWebhookEventPayloadV2Schema
];
var webhookEventPublicApiV2Schema = import_zod17.default.union(webhookEventSchemas);
var getSchemaTitle = (schema, fallback) => {
  if (schema.title)
    return schema.title;
  return fallback;
};
var getSchemaDescription = (schema) => {
  if (schema.description)
    return schema.description;
  return void 0;
};
var webhookPublicApiV2EventsSpec = webhookEventSchemas.map(
  (schema) => {
    const jsonSchema = (0, import_zod_openapi.generateSchema)(schema);
    const event = schema.shape.event.value;
    const title = getSchemaTitle(jsonSchema, event);
    return {
      event,
      title,
      description: getSchemaDescription(jsonSchema),
      example: jsonSchema.example,
      schema: jsonSchema
    };
  }
);

// src/contracts/invoice.contract.ts
var import_ai_constants13 = require("ai-constants");
var import_zod18 = __toESM(require("zod"));
var invoiceSchema = import_zod18.default.object({
  companyId: import_zod18.default.string().min(1, "Company ID is required"),
  invoiceNumber: import_zod18.default.string({
    required_error: "Campo requerido"
  }).nullish(),
  issuingDate: import_zod18.default.coerce.date({
    required_error: "Campo requerido",
    invalid_type_error: "Fecha inv\xE1lida"
  }),
  dueDate: import_zod18.default.coerce.date({
    required_error: "Campo requerido",
    invalid_type_error: "Fecha inv\xE1lida"
  }).nullish(),
  status: import_zod18.default.enum(import_ai_constants13.invoiceStatuses, {
    required_error: "Campo requerido"
  }),
  currency: import_zod18.default.enum(import_ai_constants13.currencies, {
    required_error: "Campo requerido"
  }),
  amount: import_zod18.default.number({
    required_error: "Campo requerido"
  }).min(0, "Amount must be greater than 0"),
  fileToken: import_zod18.default.string().min(1, "File token is required"),
  paymentDate: import_zod18.default.coerce.date({
    required_error: "Campo requerido",
    invalid_type_error: "Fecha inv\xE1lida"
  }).nullish()
});
var createInvoiceRequestBody = invoiceSchema;
var applyInvoiceRefinements = (schema) => (
  //@ts-ignore
  schema.superRefine((data, ctx) => {
    if (data.status === "paid" && !data.paymentDate) {
      ctx.addIssue({
        code: import_zod18.default.ZodIssueCode.custom,
        message: "Fecha de pago requerida",
        path: ["paymentDate"]
      });
    }
  })
);
var createInvoiceResponseBody = import_zod18.default.object({
  _id: import_zod18.default.string()
});
var listInvoicesRequestQuery = dataTableRequestQuerySchema;
var listInvoicesResponseBody = createPaginationResponseSchema(
  invoiceSchema.extend({
    company: companySchema,
    _id: import_zod18.default.string(),
    file: import_zod18.default.object({
      originalName: import_zod18.default.string(),
      storedName: import_zod18.default.string(),
      size: import_zod18.default.number(),
      type: import_zod18.default.string(),
      extension: import_zod18.default.string(),
      mimetype: import_zod18.default.string(),
      originalUploadedAt: import_zod18.default.coerce.date().nullish(),
      url: import_zod18.default.string().nullish()
    })
  })
);
var updateInvoiceRequestBody = invoiceSchema.omit({
  companyId: true
});
var invoiceRequestParams = import_zod18.default.object({
  invoiceId: import_zod18.default.string().min(1, "Invoice ID is required")
});

// src/schemas/file.ts
var import_zod19 = require("zod");
var tokenizeFileRequestBody = import_zod19.z.object({
  name: import_zod19.z.string(),
  size: import_zod19.z.number()
});

// src/schemas/billing.ts
var import_ai_constants14 = require("ai-constants");
var import_zod20 = __toESM(require("zod"));
var import_ai_constants15 = require("ai-constants");
var retrieveCompanySubscriptionResponseBody = import_zod20.default.object({
  subscription: import_zod20.default.object({
    startDate: import_zod20.default.coerce.date().nullish(),
    endDate: import_zod20.default.coerce.date().nullish(),
    status: import_zod20.default.enum(import_ai_constants14.subscriptionStatuses),
    plan: planSchema,
    addonPlans: import_zod20.default.array(
      addonPlanSchemaBase.extend({
        _id: import_zod20.default.any(),
        status: import_zod20.default.enum(import_ai_constants14.subscriptionStatuses),
        canceledAt: import_zod20.default.coerce.date().nullish()
      })
    )
  }),
  currentBillingPeriod: import_zod20.default.object({
    startDate: import_zod20.default.object({
      formatted: import_zod20.default.string(),
      isoValue: import_zod20.default.string()
    }),
    endDate: import_zod20.default.object({
      formatted: import_zod20.default.string(),
      isoValue: import_zod20.default.string()
    })
  }),
  nextBillingPeriod: import_zod20.default.object({
    startDate: import_zod20.default.coerce.date()
  }),
  usage: import_zod20.default.array(
    import_zod20.default.object({
      resource: import_zod20.default.enum(import_ai_constants14.planLimitResources),
      currentUsage: import_zod20.default.number(),
      limit: import_zod20.default.number(),
      subscriptionId: import_zod20.default.any(),
      periodStart: import_zod20.default.coerce.date(),
      periodEnd: import_zod20.default.coerce.date().nullish(),
      limitReached: import_zod20.default.boolean().nullish(),
      model: import_zod20.default.enum(import_ai_constants15.planLimitModels)
    })
  ),
  aggregatedLimits: import_zod20.default.array(planLimitSchema),
  usagePeriods: import_zod20.default.array(
    import_zod20.default.object({
      periodStart: import_zod20.default.object({
        formatted: import_zod20.default.string(),
        isoValue: import_zod20.default.string()
      }),
      periodEnd: import_zod20.default.object({
        formatted: import_zod20.default.string(),
        isoValue: import_zod20.default.string()
      })
    })
  )
});
var retrieveCompanySubscriptionRequestQuery = import_zod20.default.object({
  startDate: import_zod20.default.coerce.date().nullish(),
  endDate: import_zod20.default.coerce.date().nullish()
});

// src/schemas/guest.ts
var import_zod21 = __toESM(require("zod"));
var import_validator6 = require("validator");
var retrieveGuestRequestParams = import_zod21.default.object({
  guestId: import_zod21.default.string().refine(import_validator6.isMongoId)
});
var retrieveGuestRequestQuery = import_zod21.default.object({
  token: import_zod21.default.string()
});
var retrieveGuestResponseBody = import_zod21.default.object({
  _id: import_zod21.default.any(),
  createdAt: import_zod21.default.coerce.date(),
  policyName: import_zod21.default.string().nullish(),
  token: import_zod21.default.string(),
  email: import_zod21.default.string(),
  internalId: import_zod21.default.string().nullish(),
  company: companySchema.pick({
    _id: true,
    societyReason: true,
    fantasyName: true,
    authConfig: true
  }),
  host: import_zod21.default.object({
    name: import_zod21.default.string(),
    email: import_zod21.default.string(),
    username: import_zod21.default.string()
  }).nullish()
});
var registerUserGuestRequestBody = import_zod21.default.object({
  firstName: import_zod21.default.string().min(1, "Campo requerido"),
  lastName: import_zod21.default.string().min(1, "Campo requerido"),
  password: import_zod21.default.string().min(1, "Campo requerido").min(5, "M\xEDnimo 5 caracteres"),
  acceptTerms: import_zod21.default.boolean().refine((value) => !!value, {
    message: "Debe aceptar los t\xE9rminos y condiciones"
  })
});

// src/schemas/user.ts
var import_ai_constants16 = require("ai-constants");
var import_zod22 = require("zod");
var loginUserIDPRequestBody = import_zod22.z.object({
  provider: import_zod22.z.enum(["google"]),
  token: import_zod22.z.string()
});
var registerInvitationIDPRequestBody = loginUserIDPRequestBody;
var signInMethodSchema = import_zod22.z.enum(["google", "microsoft", "email"]);
var registerUserEventRequestBody = import_zod22.z.object({
  events: import_zod22.z.array(
    import_zod22.z.discriminatedUnion("event", [
      import_zod22.z.object({
        event: import_zod22.z.literal("page_viewed"),
        data: import_zod22.z.object({
          page: import_zod22.z.enum(import_ai_constants16.eventPages)
        }),
        timestamp: import_zod22.z.number()
      }),
      import_zod22.z.object({
        event: import_zod22.z.literal("create_inspection_page_viewed"),
        data: import_zod22.z.object({
          inspection_type: import_zod22.z.enum(import_ai_constants16.inspectionTypes)
        }),
        timestamp: import_zod22.z.number()
      }),
      import_zod22.z.object({
        event: import_zod22.z.literal("inspection_list_filters_applied"),
        data: import_zod22.z.object({}),
        timestamp: import_zod22.z.number()
      }),
      import_zod22.z.object({
        event: import_zod22.z.literal("template_updated"),
        data: import_zod22.z.object({
          template_id: import_zod22.z.string(),
          template_name: import_zod22.z.string(),
          template_type: import_zod22.z.enum(import_ai_constants16.templateTypes),
          inspection_type: import_zod22.z.enum(import_ai_constants16.inspectionTypes)
        }),
        timestamp: import_zod22.z.number()
      }),
      import_zod22.z.object({
        event: import_zod22.z.literal("view_wrapped_button_clicked"),
        data: import_zod22.z.object({
          year: import_zod22.z.number()
        }),
        timestamp: import_zod22.z.number()
      }),
      import_zod22.z.object({
        event: import_zod22.z.literal("view_wrapped_button_impression"),
        data: import_zod22.z.object({
          year: import_zod22.z.number()
        }),
        timestamp: import_zod22.z.number()
      }),
      import_zod22.z.object({
        event: import_zod22.z.literal("wrapped_slide_viewed"),
        data: import_zod22.z.object({
          year: import_zod22.z.number(),
          slide: import_zod22.z.enum([
            "intro",
            "inspections-count",
            "weeks-active",
            "hours-saved",
            "fraud-alerts",
            "user-profile",
            "thank-you"
          ])
        }),
        timestamp: import_zod22.z.number()
      }),
      import_zod22.z.object({
        event: import_zod22.z.literal("view_wrapped_button_dismissed"),
        data: import_zod22.z.object({
          year: import_zod22.z.number()
        }),
        timestamp: import_zod22.z.number()
      }),
      import_zod22.z.object({
        event: import_zod22.z.literal("wrapped_share_button_clicked"),
        data: import_zod22.z.object({
          year: import_zod22.z.number()
        }),
        timestamp: import_zod22.z.number()
      }),
      import_zod22.z.object({
        event: import_zod22.z.literal("inspection_file_viewed"),
        data: import_zod22.z.object({
          inspection_id: import_zod22.z.string(),
          template_id: import_zod22.z.string(),
          template_name: import_zod22.z.string(),
          inspection_type: import_zod22.z.enum(import_ai_constants16.inspectionTypes),
          file_type: import_zod22.z.enum(["image", "audio", "video", "file", "document"]),
          file_name: import_zod22.z.string(),
          file_asset_label: import_zod22.z.string(),
          file_asset_type: import_zod22.z.enum(import_ai_constants16.assetTypes),
          file_asset_identifier: import_zod22.z.string()
        }),
        timestamp: import_zod22.z.number()
      }),
      import_zod22.z.object({
        event: import_zod22.z.literal("inspection_validations_preview_opened"),
        data: import_zod22.z.object({
          inspection_id: import_zod22.z.string(),
          template_id: import_zod22.z.string(),
          template_name: import_zod22.z.string(),
          inspection_type: import_zod22.z.enum(import_ai_constants16.inspectionTypes),
          validations_type: import_zod22.z.enum(["required", "extra"]),
          validations_count: import_zod22.z.number()
        }),
        timestamp: import_zod22.z.number()
      }),
      import_zod22.z.object({
        event: import_zod22.z.literal("inspection_detail_visibility_active"),
        data: import_zod22.z.object({
          inspection_id: import_zod22.z.string(),
          template_id: import_zod22.z.string(),
          template_name: import_zod22.z.string(),
          inspection_type: import_zod22.z.enum(import_ai_constants16.inspectionTypes),
          last_active_timestamp: import_zod22.z.number(),
          inactive_duration_ms: import_zod22.z.number(),
          unix_timestamp_seconds: import_zod22.z.number()
        }),
        timestamp: import_zod22.z.number()
      }),
      import_zod22.z.object({
        event: import_zod22.z.literal("inspection_detail_visibility_inactive"),
        data: import_zod22.z.object({
          inspection_id: import_zod22.z.string(),
          template_id: import_zod22.z.string(),
          template_name: import_zod22.z.string(),
          inspection_type: import_zod22.z.enum(import_ai_constants16.inspectionTypes),
          last_active_timestamp: import_zod22.z.number(),
          active_duration_ms: import_zod22.z.number(),
          unix_timestamp_seconds: import_zod22.z.number()
        }),
        timestamp: import_zod22.z.number()
      })
    ])
  )
});

// src/utils/compute-status-from-dates.ts
var import_date_fns2 = require("date-fns");
var computeStatusFromDates = (subscription) => {
  const now = /* @__PURE__ */ new Date();
  if (!subscription.startDate)
    return "pending";
  const isStarted = (0, import_date_fns2.isAfter)(now, subscription.startDate) || now.getTime() === subscription.startDate.getTime();
  if (!isStarted)
    return "pending";
  if (!subscription.endDate)
    return "active";
  const isEnded = (0, import_date_fns2.isAfter)(now, subscription.endDate);
  if (isEnded && subscription.status === "canceled")
    return "canceled";
  if (isEnded)
    return "terminated";
  return "active";
};

// src/contracts/segment.contract.ts
var import_ai_constants17 = require("ai-constants");
var import_zod23 = require("zod");
var import_date_fns3 = require("date-fns");
var requiredErrorFieldMessage = "Campo requerido";
var segmentationSimulationSchema = import_zod23.z.object({
  identity: import_zod23.z.object({
    email: import_zod23.z.string().email()
  }),
  events: import_zod23.z.array(
    import_zod23.z.object({
      uid: import_zod23.z.string(),
      type: import_zod23.z.enum(import_ai_constants17.userEvents, {
        invalid_type_error: requiredErrorFieldMessage,
        required_error: requiredErrorFieldMessage,
        message: requiredErrorFieldMessage
      }),
      timestamp: import_zod23.z.coerce.date({
        errorMap: () => {
          return {
            message: "Fecha inv\xE1lida"
          };
        }
      })
    })
  ).min(1, {
    message: "Agrega al menos un evento"
  }),
  startDate: import_zod23.z.coerce.date({
    errorMap: () => {
      return {
        message: "Fecha inv\xE1lida"
      };
    }
  }),
  endDate: import_zod23.z.coerce.date({
    errorMap: () => {
      return {
        message: "Fecha inv\xE1lida"
      };
    }
  })
});
var applySegmentationSimulationRefinements = (schema) => schema.refine(
  (data) => !!data.startDate && !!data.endDate && (0, import_date_fns3.isAfter)(new Date(data.endDate), new Date(data.startDate)),
  {
    message: "La fecha de inicio debe ser anterior a la fecha de fin",
    path: ["startDate"]
  }
);
var executeSegmentationSimulationRequestBody = applySegmentationSimulationRefinements(segmentationSimulationSchema);
var segmentSchema = import_zod23.z.object({
  type: import_zod23.z.enum(import_ai_constants17.userSegmentTypes),
  timestamp: import_zod23.z.coerce.date(),
  _id: import_zod23.z.any(),
  metadata: import_zod23.z.custom().nullish()
});
var executeSegmentationSimulationResponseBody = import_zod23.z.object({
  simulation: segmentationSimulationSchema.merge(
    import_zod23.z.object({
      id: import_zod23.z.string()
    })
  ),
  segments: import_zod23.z.array(segmentSchema)
});
var retrieveSegmentationEvolutionRequestQuery = import_zod23.z.object({
  email: import_zod23.z.string().email().transform(normalizeEmail)
});
var retrieveSegmentationEvolutionResponseBody = import_zod23.z.object({
  segments: import_zod23.z.array(segmentSchema),
  activity: import_zod23.z.array(userActivityBaseSchema)
});

// src/utils/build-user-name.ts
var buildUserName = (user) => [user.firstName, user.lastName].filter(Boolean).join(" ");

// src/inspection-result.ts
var INSPECTION_RESULT_BY_LEGACY_VEREDICT = {
  true: "approved",
  false: "disapproved"
};

// src/utils/sort-logic-rules.ts
var sortLogicRules = (logicRules = []) => {
  return [...logicRules].sort((left, right) => left.order - right.order);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DEFAULT_SEARCH_PARAMS_ACCESS_TOKEN_STRATEGY,
  INSPECTION_RESULT_BY_LEGACY_VEREDICT,
  InspectionCompletedBy,
  InspectionResult,
  VerificationStatusEnum,
  actionSources,
  addonPlanSchema,
  addonPlanSchemaBase,
  aggregatePaginateUsersRequestQuery,
  aggregatePaginateUsersResponseBody,
  aggregatedAssetTypes,
  aggregatedFileAssetTypes,
  applyAddonPlanCustomValidations,
  applyInvoiceRefinements,
  assetsSchema,
  buildUserName,
  companySchema,
  computeStatusFromDates,
  createAuthorizationURLRequestBody,
  createAuthorizationURLResponseBody,
  createInspectionPublicApiV2ResponseBodySchema,
  createInvoiceRequestBody,
  createInvoiceResponseBody,
  createSubscriptionRequestBody,
  createSubscriptionRequestParams,
  createSubscriptionResponseBody,
  createZodTypeSafeEnumOpenApi,
  defaultInspectionTableColumns,
  downloadInspectionsReportRequestBody,
  executeSegmentationSimulationRequestBody,
  executeSegmentationSimulationResponseBody,
  formatDateToLocale,
  formatDateToLocaleDays,
  getCompaniesPaginationResponseBody,
  getVehicleAngleModelUrlResponseBody,
  identityProviders,
  inspectionDetailDamagesResponseBody,
  inspectionDetailIframeRequestQuerySchema,
  inspectionResults,
  invitationTokenHeaderName,
  invitationTokenRequestQuery,
  inviteUsersRequestBody,
  inviteUsersResponseBody,
  invoiceRequestParams,
  listAllCompaniesResponseBody,
  listAssetInferenceChangelogsRequestQuery,
  listCompaniesRequestQuery,
  listCompanySubscriptionsResponseBody,
  listInferenceChangelogsResponseBodySchema,
  listInspectionChangelogsRequestQuery,
  listInspectionChangelogsResponseBodySchema,
  listInvoicesRequestQuery,
  listInvoicesResponseBody,
  listOfficeInspectionsRequestQuery,
  listOfficeInspectionsResponseBody,
  listTemplatesPublicApiV2RequestQuerySchema,
  listTemplatesPublicApiV2ResponseBodySchema,
  loginBouncedRequestQuery,
  loginUserIDPRequestBody,
  loginUserRequestBody,
  normalizeEmail,
  officeInspectionListItemSchema,
  officeUpdateTemplateRequestBody,
  onboardingInviteUsersRequestBody,
  planLimitSchema,
  planSchema,
  prepareInvoiceDownloadRequestParams,
  prepareInvoiceDownloadResponseBody,
  publicSpecTemplateInferenceSchema,
  publicSpecTemplateValidationSchema,
  registerClientInspectionEventRequestBody,
  registerClientInspectionEventResponseBody,
  registerCompanyRequestBody,
  registerCompanyResponseBody,
  registerEmailMembershipInvitationRequestBody,
  registerEmailMembershipInvitationRequestParams,
  registerEmailMembershipInvitationResponseBody,
  registerInspectionErrorRequestBody,
  registerInvitationIDPRequestBody,
  registerUserEventRequestBody,
  registerUserGuestRequestBody,
  requiredErrorFieldMessage,
  resendInvitationEmailAdminRequestBody,
  resendInvitationEmailAdminResponseBody,
  retrieveCompanyRequestParams,
  retrieveCompanyResponseBody,
  retrieveCompanySubscriptionRequestQuery,
  retrieveCompanySubscriptionResponseBody,
  retrieveGuestRequestParams,
  retrieveGuestRequestQuery,
  retrieveGuestResponseBody,
  retrieveInspectionProgressResponseBody,
  retrieveInspectionPublicApiV2ResponseBodySchema,
  retrieveInspectionSummaryRequestParams,
  retrieveMembershipFromInvitationRequestParams,
  retrieveMembershipFromInvitationResponseBody,
  retrieveSegmentationEvolutionRequestQuery,
  retrieveSegmentationEvolutionResponseBody,
  retrieveSubscriptionRequestParams,
  retrieveTemplatePublicApiV2RequestParamsSchema,
  retrieveTemplatePublicApiV2RequestQuerySchema,
  retrieveTemplatePublicApiV2ResponseAssetsExample,
  retrieveTemplatePublicApiV2ResponseBodyExample,
  retrieveTemplatePublicApiV2ResponseBodySchema,
  retrieveTemplatePublicApiV2ResponseInferencesExample,
  retrieveTemplatePublicApiV2ResponseSchemaExample,
  retrieveTemplatePublicApiV2ResponseValidationsExample,
  searchPlanRequestQuery,
  searchPlanResponseBody,
  signInMethodSchema,
  similaritySearchRequestParams,
  similaritySearchRequestQuery,
  similaritySearchResponseBody,
  similaritySearchSupportedAssetTypes,
  sortLogicRules,
  subscribeToAddonPlanRequestBody,
  templateInputWalkaroundAssetSchema,
  templateInputWalkaroundSchema,
  timeAgo,
  toInspectionResultOption,
  tokenizeFileRequestBody,
  updateCompanyConfigRequestBody,
  updateCompanyRequestBody,
  updateCompanyRequestParams,
  updateInvoiceRequestBody,
  updatePlanRequestBody,
  updatePlanRequestParams,
  updateSubscriptionRequestBody,
  updateTemplateRequestParams,
  userActivityBaseSchema,
  variableActionReferences,
  webhookEventPublicApiV2Schema,
  webhookPublicApiV2EventsSpec
});
